import React, { useState, useEffect, useRef } from 'react';

import { Card, Row, Col, Nav, Tab, Spinner, Badge, Button, Table, Modal, Form, InputGroup } from 'react-bootstrap';

import { useParams, useNavigate, useSearchParams } from 'react-router-dom';

import { oneKlicks } from '../../SDK/oneclick';

import ImageShow from '../../Uitiles/ImageShow';

import { toast } from 'react-toastify';

import formatDoctorName from '../../Uitiles/FormatName';

import Preloader from '../../Uitiles/Preloader';

import AddInvoiceModel from './Components/AddInvoiceModel';

import { FaEnvelope, FaPhone, FaMapMarkerAlt, FaGraduationCap, FaBriefcase, FaStar, FaCalendar, FaMoneyBillWave } from 'react-icons/fa';

import Paginationnew from '../../Uitiles/Paginationnew';

import { genareteInvoicePDF } from '../../services/apiService';

import DoctorSpecialities from '../../layouts/Frontend/Home/Components/DoctorSpecialities';

import { OneKlicksFileSDK } from '../../SDK/OneKlicksFileSDK';

import MonthlyPostingPlan from '../../layouts/Doctor/Components/HospitalMarketing/MonthlyPostingPlan';

import SecuritySettings from '../../layouts/Doctor/Components/AccountSettings/SecuritySettings';
import Password from '../../layouts/Doctor/Components/AccountSettings/Password';
import EmailNotification from '../../layouts/Doctor/Components/AccountSettings/EmailNotification';
import SocialAccountDetails from '../../layouts/Doctor/Components/AccountSettings/SocialAccountDetails';
import DeleteAccount from '../../layouts/Doctor/Components/AccountSettings/DeleteAccount';
import AccountSharing from '../../layouts/Doctor/Components/AccountSettings/AccountSharing';
import SeoSettings from '../../layouts/Doctor/Components/AccountSettings/SeoSettings';
import InvoiceSettings from '../../layouts/Doctor/Components/AccountSettings/InvoiceSettings';
import BankAccountDetails from '../../layouts/Doctor/Components/AccountSettings/BankAccountDetails';
import AppointmentSettingsComponent from '../../layouts/Doctor/AppointmentSettings';
import CryptoJS from "crypto-js";

// Hospital Profile Settings Components
import ProfilePersonalDetails from '../../HospitalAdmin/Components/ProfileSettings/PersonalDetails';
import ExperienceEducation from '../../HospitalAdmin/Components/ProfileSettings/ExperienceEducation';
import AwardsDownloads from '../../HospitalAdmin/Components/ProfileSettings/AwardsDownloads';
import Registrations from '../../HospitalAdmin/Components/ProfileSettings/Registrations';
import Gallery from '../../HospitalAdmin/Components/ProfileSettings/Gallery';
import Defaultlocation from '../../HospitalAdmin/Components/ProfileSettings/Defaultlocation';
import SocialProfiles from '../../HospitalAdmin/Components/ProfileSettings/Socialprofiles';

const HospitalProfileDetails = () => {

    const { id } = useParams();

    const navigate = useNavigate();

    const tabsRef = useRef(null);

    const scrollTabs = (direction) => {
        if (tabsRef.current) {
            const scrollAmount = 200;
            if (direction === 'left') {
                tabsRef.current.scrollLeft -= scrollAmount;
            } else {
                tabsRef.current.scrollLeft += scrollAmount;
            }
        }
    };
    
    const isHospital = true;
    const userRoleLabel = 'Hospital';
    const userRoleLower = 'hospital';

    const [searchParams, setSearchParams] = useSearchParams();

    const [loading, setLoading] = useState(true);

    const [doctorData, setDoctorData] = useState(null);

    const [activeTab, setActiveTab] = useState('overview');

    // Doctor Edit state

    const [showEditDoctorModal, setShowEditDoctorModal] = useState(false);

    const [editDoctorFormData, setEditDoctorFormData] = useState({

        first_name: '',

        last_name: '',

        display_name: '',

        subheading: '',

        email: '',

        phone: '',

        starting_price: '',

        rating: '',

        description: '',

        status: '1',

        gendar: '',

        dob: '',

        blood_group: '',

        languages: '',

        registration_number: '',

        registration_year: '',

        council: '',

        address: '',

        city: '',

        state: '',

        pincode: ''

    });

    // Activity Logs state

    const [activityLogs, setActivityLogs] = useState([]);

    const [logsLoading, setLogsLoading] = useState(false);

    // Doctor Specialities & Services state

    const [docSpecialities, setDocSpecialities] = useState([]);

    const [masterSpecialities, setMasterSpecialities] = useState([]);

    const [masterServices, setMasterServices] = useState([]);

    const [servicesLoading, setServicesLoading] = useState(false);

    const [servicesSaving, setServicesSaving] = useState(false);

    // Invoices state

    const [invoices, setInvoices] = useState([]);

    const [invoicesLoading, setInvoicesLoading] = useState(false);

    const [showInvoiceModal, setShowInvoiceModal] = useState(false);

    const [selectedInvoice, setSelectedInvoice] = useState(null);

    const [invoiceMode, setInvoiceMode] = useState('add');

    // Marketing tasks state

    const [marketingTasks, setMarketingTasks] = useState([]);

    const [tasksLoading, setTasksLoading] = useState(false);

    // Poster/Banner modal state

    const [showMediaModal, setShowMediaModal] = useState(false);

    const [mediaType, setMediaType] = useState(''); // 'poster' or 'banner'

    const [mediaFormData, setMediaFormData] = useState({

        id: null,

        type: '',

        name: '',

        description: '',

        date: '',

        referenceImage: null,

        referenceImage_url: '',

        referenceImage_preview: null,

        uploadFile: null,

        uploadFile_url: '',

        uploadFile_preview: null

    });

    // Appointments state

    const [appointments, setAppointments] = useState([]);

    const [appointmentsLoading, setAppointmentsLoading] = useState(false);

    // Packages state

    const [packages, setPackages] = useState([]);

    const [packagesLoading, setPackagesLoading] = useState(false);

    // Pagination

    const [page, setPage] = useState(1);

    const [limit, setLimit] = useState(10);

    const [totalPages, setTotalPages] = useState(0);

    // Account Settings State
    const [accountTab, setAccountTab] = useState("Security & Settings");
    const [oldpassword, setOldpassword] = useState("");
    const [newpassword, setNewpassword] = useState("");
    const [confirmpassword, setConfirmpassword] = useState("");
    const [email, setEmail] = useState("");
    const [oldemail, setOldemail] = useState("");
    const [emailisvalid, setEmailisvalid] = useState(false);
    const [formData, setFormData] = useState({
        password: '',
        retypePassword: '',
        reason: '',
        description: ''
    });
    const [localInvoice, setLocalInvoice] = useState({
        id: '',
        user_id: '',
        name: '',
        address: '',
        state: '',
        city: '',
        pincode: '',
        country: '',
        phone: '',
        email: '',
        website: '',
        gst_number: ''
    });

    // Profile Settings States
    const [profileSettingsTab, setProfileSettingsTab] = useState("Hospital Details");
    const [profileEducations, setProfileEducations] = useState([]);
    const [profileExperiences, setProfileExperiences] = useState([]);
    const [profileAwards, setProfileAwards] = useState([]);
    const [profileDownloads, setProfileDownloads] = useState([]);
    const [profileRegistrations, setProfileRegistrations] = useState([]);
    const [profileGalleryImages, setProfileGalleryImages] = useState([]);
    const [profileVideos, setProfileVideos] = useState([]);
    const [profileNewVideoUrl, setProfileNewVideoUrl] = useState("");
    const [profileGalleryId, setProfileGalleryId] = useState([]);
    const [profileSelectedCountry, setProfileSelectedCountry] = useState('india');
    const [profileSearchAddress, setProfileSearchAddress] = useState('');
    const [profileMapCenter, setProfileMapCenter] = useState({ lat: 20.5937, lng: 78.9629 });
    const [profileFullAddress, setProfileFullAddress] = useState('');
    const [profilePersonalDetailsFormdata, setProfilePersonalDetailsFormdata] = useState({
        name: "",
        gendar: "",
        subheading: "",
        first_name: "",
        last_name: "",
        display_name: "",
        starting_price: "",
        mobile_number: "",
        description: "",
        languages: [],
        profile_photo: null,
        profile_banner: null,
        profile_photo_url: null,
        profile_banner_url: null,
        memberships: [],
        hospital_name: "",
        contact_person_email: "",
        contact_person_phone: "",
    });
    const [profileSocialProfiles, setProfileSocialProfiles] = useState({
        facebook: "",
        twitter: "",
        linkedin: "",
        skype: "",
        pinterest: "",
        tumblr: "",
        instagram: "",
        flickr: "",
        medium: "",
        tripadvisor: "",
        wikipedia: "",
        vimeo: "",
        youtube: "",
        whatsapp: "",
        vkontakte: "",
        odnoklassniki: "",
        googleplus: "",
        telegram: "",
        twitch: "",
        discord: "",
        github: "",
        reddit: "",
        stackoverflow: ""
    });
    const [profileSocialLoading, setProfileSocialLoading] = useState(true);
    const [profileIsUploading, setProfileIsUploading] = useState(false);
    const [profileIsSaving, setProfileIsSaving] = useState(false);
    const [profileHasChanges, setProfileHasChanges] = useState(false);

    useEffect(() => {
        if (doctorData) {
            setEmail(doctorData.email || "");
            setOldemail(doctorData.email || "");
            setEmailisvalid(doctorData.activation_key || false);
            fetchProfilePersonalDetails();
            fetchProfileSocialProfiles();
            fetchProfileDefaultLocation();
            fetchProfileGallery();
            fetchProfileAwardsDownloads();
            fetchProfileRegistrations();
            fetchProfileExperienceEducation();
        }
    }, [doctorData]);

    const logAdminActivity = async (activityType, descriptionText) => {
        try {
            const loggedInUserStr = localStorage.getItem("userData") || localStorage.getItem("presentuser");
            const loggedInUser = loggedInUserStr ? JSON.parse(loggedInUserStr) : {};
            const adminId = loggedInUser?.id || 1;
            const logPayload = {
                employee_id: adminId,
                activity_type: activityType,
                description: `Admin ${descriptionText} for hospital profile for ID: ${id} (${doctorData?.first_name || ''} ${doctorData?.last_name || ''})`,
                ip_address: '127.0.0.1',
                created_at: new Date().toISOString()
            };
            await oneKlicks.create('', 'user_activity_logs', logPayload, {});
            await fetchActivityLogs(); // Auto-refresh logs instantly!
        } catch (e) {
            console.error("Failed to log activity:", e);
        }
    };

    const handleAdminPasswordSubmit = async (e) => {
        e.preventDefault();
        const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
        if (!passwordRegex.test(newpassword)) {
            toast.error("Password must be at least 8 characters long and contain uppercase, lowercase, number and special character");
            return;
        }

        if (newpassword !== confirmpassword) {
            toast.error("New password and confirm password do not match");
            return;
        }

        try {
            const newpasswordhash = CryptoJS.SHA256(newpassword).toString();

            const tableSchema = "";
            const tableName = "users";
            const data = {
                "pass": newpasswordhash
            };
            const condition = {
                id: id
            };
            const updateData = await oneKlicks.update(tableSchema, tableName, data, condition);

            if (updateData.success) {
                toast.success("Password updated successfully by Admin");
                setOldpassword("");
                setNewpassword("");
                setConfirmpassword("");
                await logAdminActivity("password_update", "updated doctor password");
            } else {
                toast.error("Failed to update password. Please try again.");
            }
        } catch (error) {
            console.error("Password update error:", error);
            toast.error("An error occurred while updating password");
        }
    };

    const handleAdminEmailSubmit = async (e) => {
        e.preventDefault();
        try {
            const tableSchema = "";
            const tableName = "users";
            const data = {
                "email": email
            };
            const condition = {
                id: id
            };
            const updateData = await oneKlicks.update(tableSchema, tableName, data, condition);
            if (updateData.success) {
                toast.success("Email updated successfully by Admin");
                fetchDoctorData();
                await logAdminActivity("email_update", `updated registered email from "${oldemail}" to "${email}"`);
            } else {
                toast.error("Failed to update email. Please try again.");
            }
        } catch (error) {
            console.error("Email update error:", error);
            toast.error("An error occurred while updating email");
        }
    };

    const handleAdminDeleteAccount = async (e) => {
        e.preventDefault();
        try {
            const tableSchema = "";
            const tableName = "users";
            const data = {
                "status": "2"
            };
            const condition = {
                id: id
            };
            const updateData = await oneKlicks.update(tableSchema, tableName, data, condition);
            if (updateData.success) {
                const deleteReqTable = "user_delete_requests";
                const deleteReqData = {
                    "reason": formData.reason || "Deleted by Administrator",
                    "description": formData.description || "",
                    "status": "2",
                    "user_id": id,
                    "email": doctorData.email,
                    "deleted_at": new Date().toISOString(),
                    "phone": doctorData.phone
                };
                const deleteReqCond = {
                    "user_id": id
                };
                await oneKlicks.update(tableSchema, deleteReqTable, deleteReqData, deleteReqCond);
                
                toast.success("Account deleted successfully by Admin");
                await logAdminActivity("delete_account", `deleted doctor account. Reason: "${formData.reason || "Deleted by Administrator"}"`);
                navigate("/admin/doctors");
            } else {
                toast.error("Failed to delete account. Please try again.");
            }
        } catch (error) {
            console.error("Delete account error:", error);
            toast.error("An error occurred while deleting account");
        }
    };

    const handleAdminInvoiceSettings = async (e) => {
        try {
            e.preventDefault();
            const tableSchema = "";
            const tableName = "users_billing_details";
            
            const data = {
                "user_id": id,
                "name": localInvoice.name,
                "address": localInvoice.address,
                "state": localInvoice.state,
                "city": localInvoice.city,
                "pincode": localInvoice.pincode,
                "country": localInvoice.country,
                "phone": localInvoice.phone,
                "email": localInvoice.email,
                "website": localInvoice.website,
                "gst_number": localInvoice.gst_number
            };
            let response;
            if (localInvoice.id) {
                const conditions = {
                    "user_id": id
                };
                response = await oneKlicks.update(tableSchema, tableName, data, conditions);
            } else {
                const conditions = {
                    "id": localInvoice.id,
                    "user_id": id
                };
                response = await oneKlicks.create(tableSchema, tableName, data, conditions);
            }
            if (response.success) {
                toast.success("Invoice settings updated successfully");
                await logAdminActivity("invoice_update", `${localInvoice.id ? 'updated' : 'created'} billing/invoice settings`);
            } else {
                toast.error("Failed to update invoice settings. Please try again.");
            }
        } catch (error) {
            console.error("Invoice update error:", error);
            toast.error("An error occurred while updating invoice settings");
        }
    };

    useEffect(() => {

        if (id) {

            fetchDoctorData();

            fetchMasterSpecialities();

            fetchMasterServices();

        }

        // Set active tab from URL params

        const tab = searchParams.get('tab');

        if (tab) {

            setActiveTab(tab);

        }

    }, [id]);

    useEffect(() => {

        // Load data based on active tab

        switch (activeTab) {

            case 'invoices':

                fetchInvoices();

                break;

            case 'marketing':

                fetchMarketingTasks();

                break;

            case 'appointments':

                fetchAppointments();

                break;

            case 'packages':

                fetchPackages();

                break;

            case 'services':

                fetchDoctorSpecialitiesAndServices();

                break;

            case 'logs':

                fetchActivityLogs();

                break;

            default:

                break;

        }

    }, [activeTab, page]);

    const fetchActivityLogs = async () => {

        try {

            setLogsLoading(true);

            const tableSchema = '';

            const tableName = 'user_activity_logs';

            const conditions = {};

            const orderBy = 'id DESC';

            // Search description for logs referencing this doctor or hospital

            // Search description for logs referencing this doctor

            const search = { description: `hospital profile for ID: ${id}` };

            const pagination = JSON.stringify({ page, limit });

            const margedata = '';

            const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);

            if (response.data) {

                setActivityLogs(response.data);

                setTotalPages(Math.ceil(response.pagination?.total / limit) || 0);

            } else {

                setActivityLogs([]);

            }

        } catch (error) {

            console.error('Error fetching activity logs:', error);

            setActivityLogs([]);

        } finally {

            setLogsLoading(false);

        }

    };

    const fetchMasterSpecialities = async () => {

        try {

            const response = await oneKlicks.read("", "specialities", {}, "id ASC", "", "", "");

            if (response.success && response.data) {

                setMasterSpecialities(response.data);

                return response.data;

            }

            return [];

        } catch (error) {

            console.error("Failed to load master specialities:", error);

            return [];

        }

    };

    const fetchMasterServices = async () => {

        try {

            const response = await oneKlicks.read("", "services", {}, "id ASC", "", "", "");

            if (response.success && response.data) {

                setMasterServices(response.data);

                return response.data;

            }

            return [];

        } catch (error) {

            console.error("Failed to load master services:", error);

            return [];

        }

    };

    const fetchDoctorSpecialitiesAndServices = async () => {

        try {

            setServicesLoading(true);

            const mSpecs = await fetchMasterSpecialities();

            const mSrvs = await fetchMasterServices();

            const response = await oneKlicks.read("", "doctor_specialities", { doctor_id: String(id) }, "id DESC", "", "", "");

            if (response.success && response.data) {

                const grouped = {};

                response.data.forEach(item => {

                    const specId = String(item.speciality_id);

                    if (!grouped[specId]) {

                        grouped[specId] = {

                            id: `spec_${specId}`,

                            speciality: specId,

                            services: []

                        };

                    }

                    grouped[specId].services.push({

                        id: `srv_${item.id}`,

                        service: item.service_id,

                        price: item.price,

                        description: item.description || '',

                        old_service_id: item.id,

                        name: item.name

                    });

                });

                setDocSpecialities(Object.values(grouped));

            } else {

                setDocSpecialities([]);

            }

        } catch (error) {

            console.error("Failed to load doctor specialities:", error);

            toast.error("Failed to load doctor specialities");

        } finally {

            setServicesLoading(false);

        }

    };

    const handleAddDocSpeciality = () => {

        const allSpecIds = docSpecialities.map(s => String(s.speciality));

        const available = masterSpecialities.find(opt => !allSpecIds.includes(String(opt.id)));

        if (!available) {

            toast.info('All available specialities are already added');

            return;

        }

        const newId = `temp_${Date.now()}`;

        setDocSpecialities([{ id: newId, speciality: String(available.id), services: [] }, ...docSpecialities]);

    };

    const handleAddDocService = (specId) => {

        setDocSpecialities(docSpecialities.map(spec => {

            if (spec.id === specId) {

                const existingSrvIds = (spec.services || []).map(s => String(s.service));

                const available = masterServices.find(srv =>

                    String(srv.speciality_id) === String(spec.speciality) &&

                    !existingSrvIds.includes(String(srv.id))

                );

                const newSrv = {

                    id: `temp_srv_${Date.now()}`,

                    service: available ? available.id : null,

                    price: "",

                    description: ""

                };

                return { ...spec, services: [newSrv, ...(spec.services || [])] };

            }

            return spec;

        }));

    };

    const handleRemoveDocSpeciality = async (specId) => {

        const specToDelete = docSpecialities.find(spec => spec.id === specId);

        if (specToDelete) {

            // Find all services under this specialty that have old_service_id (i.e. already saved in DB)

            const dbServices = (specToDelete.services || []).filter(s => s.old_service_id);

            if (dbServices.length > 0) {

                try {

                    const deletePromises = dbServices.map(s =>

                        oneKlicks.delete("", "doctor_specialities", { id: s.old_service_id })

                    );

                    await Promise.all(deletePromises);

                    toast.success("Speciality and its services removed successfully");

                    // Audit Log the removal!

                    try {

                        const loggedInUserStr = localStorage.getItem("userData");

                        const loggedInUser = loggedInUserStr ? JSON.parse(loggedInUserStr) : {};

                        const adminId = loggedInUser?.id || 1;

                        const logPayload = {

                            employee_id: adminId,

                            activity_type: 'update_services',

                            description: `Admin removed speciality ID ${specToDelete.speciality} and its ${dbServices.length} services from hospital profile for ID: ${id} (${doctorData?.first_name} ${doctorData?.last_name})`,

                            ip_address: '127.0.0.1',

                            created_at: new Date().toISOString()

                        };

                        oneKlicks.create('', 'user_activity_logs', logPayload, {});

                    } catch (e) {

                        console.error(e);

                    }

                } catch (err) {

                    toast.error("Failed to delete speciality services from database");

                    return;

                }

            }

        }

        setDocSpecialities(docSpecialities.filter(spec => spec.id !== specId));

    };

    const handleRemoveDocService = async (specId, srvId) => {

        setDocSpecialities(docSpecialities.map(spec => {

            if (spec.id === specId) {

                const srvToDelete = spec.services.find(s => s.id === srvId);

                if (srvToDelete?.old_service_id) {

                    oneKlicks.delete("", "doctor_specialities", { id: srvToDelete.old_service_id })

                        .then(() => {

                            toast.success("Service removed from profile successfully");

                            // Audit Log the removal!

                            try {

                                const loggedInUserStr = localStorage.getItem("userData");

                                const loggedInUser = loggedInUserStr ? JSON.parse(loggedInUserStr) : {};

                                const adminId = loggedInUser?.id || 1;

                                const logPayload = {

                                    employee_id: adminId,

                                    activity_type: 'update_services',

                                    description: `Admin removed service ID ${srvToDelete.old_service_id} from hospital profile for ID: ${id} (${doctorData?.first_name} ${doctorData?.last_name})`,

                                    ip_address: '127.0.0.1',

                                    created_at: new Date().toISOString()

                                };

                                oneKlicks.create('', 'user_activity_logs', logPayload, {});

                            } catch (e) {

                                console.error(e);

                            }

                        })

                        .catch(() => toast.error("Failed to remove service"));

                }

                return { ...spec, services: spec.services.filter(s => s.id !== srvId) };

            }

            return spec;

        }));

    };

    const handleDocServiceChange = (specId, srvId, field, value) => {

        setDocSpecialities(docSpecialities.map(spec => {

            if (spec.id === specId) {

                return {

                    ...spec,

                    services: spec.services.map(srv =>

                        srv.id === srvId ? { ...srv, [field]: value } : srv

                    )

                };

            }

            return spec;

        }));

    };

    const handleDocSpecialityChange = (specId, val) => {

        setDocSpecialities(docSpecialities.map(spec =>

            spec.id === specId ? { ...spec, speciality: val, services: [] } : spec

        ));

    };

    const handleSaveDocServices = async () => {

        setServicesSaving(true);

        try {

            const allSrvs = docSpecialities.flatMap(spec =>

                (spec.services || []).map(srv => ({ ...srv, specId: spec.speciality }))

            );

            const addedCount = [];

            const updatedCount = [];

            for (const srv of allSrvs) {

                if (!srv.service) continue;

                const data = {

                    speciality_id: String(srv.specId),

                    service_id: String(srv.service),

                    price: srv.price !== undefined && srv.price !== null ? String(srv.price) : '',

                    description: srv.description || '',

                    doctor_id: String(id),

                    status: 'active'

                };

                if (srv.old_service_id) {

                    await oneKlicks.update("", "doctor_specialities", data, { id: srv.old_service_id });

                    updatedCount.push(srv.service);

                } else {

                    await oneKlicks.create("", "doctor_specialities", data, {});

                    addedCount.push(srv.service);

                }

            }

            toast.success("Doctor's services and specialities updated successfully!");

            // Log detailed audit report!

            try {

                const loggedInUserStr = localStorage.getItem("userData");

                const loggedInUser = loggedInUserStr ? JSON.parse(loggedInUserStr) : {};

                const adminId = loggedInUser?.id || 1;

                const logPayload = {

                    employee_id: adminId,

                    activity_type: 'update_services',

                    description: `Admin updated specialities & services for hospital profile for ID: ${id} (${doctorData?.first_name} ${doctorData?.last_name}). Added ${addedCount.length} services, updated ${updatedCount.length} services.`,

                    ip_address: '127.0.0.1',

                    created_at: new Date().toISOString()

                };

                await oneKlicks.create('', 'user_activity_logs', logPayload, {});

            } catch (logErr) {

                console.error("Failed to write services update audit log:", logErr);

            }

            await fetchDoctorSpecialitiesAndServices();

        } catch (error) {

            console.error("Failed to save doctor services:", error);

            toast.error("Failed to update services");

        } finally {

            setServicesSaving(false);

        }

    };

    const handleOpenEditDoctorModal = () => {

        setEditDoctorFormData({

            first_name: doctorData.first_name || '',

            last_name: doctorData.last_name || '',

            display_name: doctorData.display_name || '',

            subheading: doctorData.subheading || '',

            email: doctorData.email || '',

            phone: doctorData.phone || '',

            starting_price: doctorData.starting_price || '',

            rating: doctorData.rating || '',

            description: doctorData.description || '',

            status: doctorData.status || '1',

            gendar: doctorData.gendar || '',

            dob: doctorData.dob ? doctorData.dob.split('T')[0] : '',

            blood_group: doctorData.blood_group || '',

            languages: doctorData.languages || '',

            registration_number: doctorData.registration_number || '',

            registration_year: doctorData.registration_year || '',

            council: doctorData.council || '',

            address: doctorData.address || '',

            city: doctorData.city || '',

            state: doctorData.state || '',

            pincode: doctorData.pincode || ''

        });

        setShowEditDoctorModal(true);

    };

    const handleCloseEditDoctorModal = () => {

        setShowEditDoctorModal(false);

    };

    const handleEditDoctorChange = (e) => {

        const { name, value } = e.target;

        setEditDoctorFormData(prev => ({

            ...prev,

            [name]: value

        }));

    };

    const handleEditDoctorSubmit = async (e) => {

        e.preventDefault();

        try {

            setLoading(true);

            const updatedFields = {};

            const changes = [];

            // Compare fields and keep track of actual edits

            Object.keys(editDoctorFormData).forEach(key => {

                const newValue = editDoctorFormData[key];

                const oldValue = doctorData[key] || '';

                if (String(newValue).trim() !== String(oldValue).trim()) {

                    updatedFields[key] = newValue;

                    changes.push(`${key} changed from "${oldValue}" to "${newValue}"`);

                }

            });

            if (changes.length === 0) {

                toast.info('No changes were made.');

                setShowEditDoctorModal(false);

                setLoading(false);

                return;

            }

            const response = await oneKlicks.update('', 'users', updatedFields, { id: id });

            if (response.success) {

                toast.success('Doctor details updated successfully!');

                // Write detailed audit logs to user_activity_logs table!

                try {

                    const loggedInUserStr = localStorage.getItem("userData");

                    const loggedInUser = loggedInUserStr ? JSON.parse(loggedInUserStr) : {};

                    const adminId = loggedInUser?.id || 1;

                    const logPayload = {

                        employee_id: adminId,

                        activity_type: 'update_doctor',

                        description: `Admin updated hospital profile for ID: ${id} (${doctorData.first_name} ${doctorData.last_name}). Changes: ${changes.join(', ')}`,

                        ip_address: '127.0.0.1',

                        created_at: new Date().toISOString()

                    };

                    await oneKlicks.create('', 'user_activity_logs', logPayload, {});

                } catch (logErr) {

                    console.error('Failed to log audit activity:', logErr);

                }

                // Reload profile data

                await fetchDoctorData();

                setShowEditDoctorModal(false);

            } else {

                toast.error('Failed to save doctor details.');

            }

        } catch (error) {

            console.error('Error submitting hospital updates:', error);

            toast.error('Failed to update hospital details');

        } finally {

            setLoading(false);

        }

    };
    // --- PROFILE SETTINGS FETCH FUNCTIONS ---
    const fetchProfileSocialProfiles = async () => {
        setProfileSocialLoading(true);
        try {
            const response = await oneKlicks.read("", "hospitals_social_profiles", { user_id: id }, "", "", "", "");
            if (response.success && response.data && response.data.length > 0) {
                let socialData = response.data[0].social_profiles;
                if (typeof socialData === "string") {
                    try {
                        socialData = JSON.parse(socialData);
                    } catch (e) {
                        socialData = {};
                    }
                }
                setProfileSocialProfiles(prev => ({ ...prev, ...socialData }));
            }
        } catch (error) {
            console.error("Error fetching social profiles:", error);
        } finally {
            setProfileSocialLoading(false);
        }
    };

    const fetchProfileDefaultLocation = async () => {
        try {
            const response = await oneKlicks.read("", "hospitals_default_location", { user_id: id }, "", "", "", "");
            if (response.success && response.data && response.data.length > 0) {
                setProfileSelectedCountry(response.data[0].country || 'india');
                setProfileSearchAddress(response.data[0].address || '');
                setProfileMapCenter({ lat: Number(response.data[0].lat) || 20.5937, lng: Number(response.data[0].lng) || 78.9629 });
                setProfileFullAddress(response.data[0].full_address || '');
            }
        } catch (error) {
            console.error("Error fetching default location:", error);
        }
    };

    const fetchProfileGallery = async () => {
        try {
            const response = await oneKlicks.read("", "hospitals_gallery", { user_id: id }, "", "", "", "");
            if (response.success && response.data && response.data.length > 0) {
                let images = response.data[0].images;
                let videos = response.data[0].videos;
                if (typeof images === "string") {
                    try { images = JSON.parse(images); } catch (e) { images = []; }
                }
                if (typeof videos === "string") {
                    try { videos = JSON.parse(videos); } catch (e) { videos = []; }
                }
                setProfileGalleryImages(Array.isArray(images) ? images : []);
                setProfileVideos(Array.isArray(videos) ? videos : []);
                setProfileGalleryId(response.data[0].id);
            }
        } catch (error) {
            console.error("Error fetching gallery:", error);
        }
    };

    const fetchProfileAwardsDownloads = async () => {
        try {
            const response = await oneKlicks.read("", "hospitals_awards_downloads", { user_id: id }, "", "", "", "");
            if (response.success && response.data && response.data.length > 0) {
                let awards = response.data[0].awards;
                let downloads = response.data[0].downloads;
                if (typeof awards === "string") {
                    try { awards = JSON.parse(awards); } catch (e) { awards = []; }
                }
                if (typeof downloads === "string") {
                    try { downloads = JSON.parse(downloads); } catch (e) { downloads = []; }
                }
                setProfileAwards(Array.isArray(awards) ? awards : []);
                setProfileDownloads(Array.isArray(downloads) ? downloads : []);
            }
        } catch (error) {
            console.error("Error fetching awards and downloads:", error);
        }
    };

    const fetchProfileRegistrations = async () => {
        try {
            const response = await oneKlicks.read("", "hospitals_registrations", { user_id: id }, "", "", "", "");
            if (response.success && response.data && response.data.length > 0) {
                let registrations = response.data[0].registrations;
                if (typeof registrations === "string") {
                    try { registrations = JSON.parse(registrations); } catch (e) { registrations = []; }
                }
                setProfileRegistrations(Array.isArray(registrations) ? registrations : []);
            }
        } catch (error) {
            console.error("Error fetching registrations:", error);
        }
    };

    const fetchProfileExperienceEducation = async () => {
        try {
            const response = await oneKlicks.read("", "hospitals_experience_education", { user_id: id }, "", "", "", "");
            if (response.success && response.data && response.data.length > 0) {
                let educations = response.data[0].educations;
                let experiences = response.data[0].experiences;
                if (typeof educations === "string") {
                    try { educations = JSON.parse(educations); } catch (e) { educations = []; }
                }
                if (typeof experiences === "string") {
                    try { experiences = JSON.parse(experiences); } catch (e) { experiences = []; }
                }
                setProfileEducations(Array.isArray(educations) ? educations : []);
                setProfileExperiences(Array.isArray(experiences) ? experiences : []);
            }
        } catch (error) {
            console.error("Error fetching experience/education:", error);
        }
    };

    const fetchProfilePersonalDetails = async () => {
        if (doctorData) {
            let languages = doctorData.languages;
            let memberships = doctorData.memberships;
            if (typeof languages === 'string') {
                try { languages = JSON.parse(languages); } catch (e) { languages = []; }
            }
            if (typeof memberships === 'string') {
                try { memberships = JSON.parse(memberships); } catch (e) { memberships = []; }
            }
            setProfilePersonalDetailsFormdata({
                name: doctorData.name || "",
                gendar: doctorData.gendar || "",
                subheading: doctorData.subheading || "",
                first_name: doctorData.first_name || "",
                last_name: doctorData.last_name || "",
                display_name: doctorData.display_name || "",
                starting_price: doctorData.starting_price || "",
                mobile_number: doctorData.phone || "",
                description: doctorData.description || "",
                languages: languages || [],
                profile_photo: doctorData.profile_photo || null,
                profile_photo_url: doctorData.profile_photo_url || null,
                profile_banner: doctorData.profile_banner || null,
                profile_banner_url: doctorData.profile_banner_url || null,
                memberships: memberships || [],
                hospital_name: doctorData.hospital_name || "",
                contact_person_email: doctorData.contact_person_email || "",
                contact_person_phone: doctorData.contact_person_phone || "",
            });
        }
    };

    // --- PROFILE SETTINGS SUBMIT HANDLERS ---
    const handleProfilePersonalDetailsSubmit = async (e) => {
        e.preventDefault();
        if (!profilePersonalDetailsFormdata.first_name || !profilePersonalDetailsFormdata.last_name) {
            toast.error("First name and last name are required");
            return;
        }
        if (!profilePersonalDetailsFormdata.mobile_number) {
            toast.error("Mobile number is required");
            return;
        }
        if (!profilePersonalDetailsFormdata.description) {
            toast.error("Description is required");
            return;
        }

        try {
            setLoading(true);
            const file = profilePersonalDetailsFormdata.profile_photo;
            let profilePhotoId = profilePersonalDetailsFormdata.profile_photo;
            let profilePhotoUrl = profilePersonalDetailsFormdata.profile_photo_url;

            if (file instanceof File) {
                const uploadedFile = await OneKlicksFileSDK.uploadFile("doctors/profile", "public", file);
                if (uploadedFile.success) {
                    profilePhotoId = uploadedFile.fileId;
                    profilePhotoUrl = uploadedFile.fileUrl;
                }
            }

            const data = {
                gendar: profilePersonalDetailsFormdata.gendar,
                subheading: profilePersonalDetailsFormdata.subheading,
                first_name: profilePersonalDetailsFormdata.first_name,
                last_name: profilePersonalDetailsFormdata.last_name,
                display_name: profilePersonalDetailsFormdata.display_name,
                starting_price: profilePersonalDetailsFormdata.starting_price,
                phone: profilePersonalDetailsFormdata.mobile_number,
                description: profilePersonalDetailsFormdata.description,
                languages: JSON.stringify(profilePersonalDetailsFormdata.languages),
                profile_photo: profilePhotoId,
                profile_photo_url: profilePhotoUrl,
                profile_banner: profilePersonalDetailsFormdata.profile_banner,
                profile_banner_url: profilePersonalDetailsFormdata.profile_banner_url,
                memberships: JSON.stringify(profilePersonalDetailsFormdata.memberships),
                hospital_name: profilePersonalDetailsFormdata.hospital_name,
                contact_person_email: profilePersonalDetailsFormdata.contact_person_email,
                contact_person_phone: profilePersonalDetailsFormdata.contact_person_phone,
            };

            const response = await oneKlicks.update("", "users", data, { id: id });
            if (response.success) {
                toast.success("Hospital Details updated successfully by Admin");
                await logAdminActivity("profile_details_update", "updated hospital personal details");
                await fetchDoctorData();
            } else {
                toast.error("Failed to update hospital details");
            }
        } catch (error) {
            console.error("Error updating details:", error);
            toast.error("An error occurred");
        } finally {
            setLoading(false);
        }
    };

    const handleProfileExperienceEducationSubmit = async (e) => {
        e.preventDefault();
        try {
            setLoading(true);
            const data = {
                user_id: id,
                educations: JSON.stringify(profileEducations),
                experiences: JSON.stringify(profileExperiences)
            };
            const response = await oneKlicks.update("", "hospitals_experience_education", data, { user_id: id });
            if (response.success) {
                toast.success("Experience & Education updated successfully by Admin");
                await logAdminActivity("experience_education_update", "updated experience and education settings");
                await fetchProfileExperienceEducation();
            } else {
                toast.error("Failed to update experience and education");
            }
        } catch (error) {
            console.error("Error:", error);
            toast.error("An error occurred");
        } finally {
            setLoading(false);
        }
    };

    const handleProfileAwardsDownloadsSubmit = async (e) => {
        e.preventDefault();
        try {
            setLoading(true);
            const data = {
                user_id: id,
                awards: JSON.stringify(profileAwards),
                downloads: JSON.stringify(profileDownloads)
            };
            const response = await oneKlicks.update("", "hospitals_awards_downloads", data, { user_id: id });
            if (response.success) {
                toast.success("Awards & Downloads updated successfully by Admin");
                await logAdminActivity("awards_downloads_update", "updated awards & downloads settings");
                await fetchProfileAwardsDownloads();
            } else {
                toast.error("Failed to update awards and downloads");
            }
        } catch (error) {
            console.error("Error:", error);
            toast.error("An error occurred");
        } finally {
            setLoading(false);
        }
    };

    const handleProfileRegistrationsSubmit = async (e) => {
        e.preventDefault();
        try {
            setLoading(true);
            const data = {
                user_id: id,
                registrations: JSON.stringify(profileRegistrations)
            };
            const response = await oneKlicks.update("", "hospitals_registrations", data, { user_id: id });
            if (response.success) {
                toast.success("Registrations updated successfully by Admin");
                await logAdminActivity("registrations_update", "updated registrations settings");
                await fetchProfileRegistrations();
            } else {
                toast.error("Failed to update registrations");
            }
        } catch (error) {
            console.error("Error:", error);
            toast.error("An error occurred");
        } finally {
            setLoading(false);
        }
    };

    const handleProfileGallerySubmit = async (e) => {
        e.preventDefault();
        try {
            setLoading(true);
            const data = {
                user_id: id,
                images: JSON.stringify(profileGalleryImages),
                videos: JSON.stringify(profileVideos)
            };
            const response = await oneKlicks.update("", "hospitals_gallery", data, { user_id: id });
            if (response.success) {
                toast.success("Gallery updated successfully by Admin");
                await logAdminActivity("gallery_update", "updated gallery settings");
                await fetchProfileGallery();
            } else {
                toast.error("Failed to update gallery");
            }
        } catch (error) {
            console.error("Error:", error);
            toast.error("An error occurred");
        } finally {
            setLoading(false);
        }
    };

    const handleProfileDefaultLocationSubmit = async (e) => {
        e.preventDefault();
        try {
            setLoading(true);
            const data = {
                user_id: id,
                country: profileSelectedCountry,
                address: profileSearchAddress,
                lat: profileMapCenter.lat,
                lng: profileMapCenter.lng,
                full_address: profileFullAddress
            };
            const response = await oneKlicks.update("", "hospitals_default_location", data, { user_id: id });
            if (response.success) {
                toast.success("Default location updated successfully by Admin");
                await logAdminActivity("default_location_update", "updated default location settings");
                await fetchProfileDefaultLocation();
            } else {
                toast.error("Failed to update default location");
            }
        } catch (error) {
            console.error("Error:", error);
            toast.error("An error occurred");
        } finally {
            setLoading(false);
        }
    };

    const handleProfileSocialProfilesSubmit = async (e) => {
        e.preventDefault();
        try {
            setLoading(true);
            const data = {
                user_id: id,
                social_profiles: JSON.stringify(profileSocialProfiles)
            };
            const response = await oneKlicks.update("", "hospitals_social_profiles", data, { user_id: id });
            if (response.success) {
                toast.success("Social profiles updated successfully by Admin");
                await logAdminActivity("social_profiles_update", "updated social profiles settings");
                await fetchProfileSocialProfiles();
            } else {
                toast.error("Failed to update social profiles");
            }
        } catch (error) {
            console.error("Error:", error);
            toast.error("An error occurred");
        } finally {
            setLoading(false);
        }
    };

    const fetchDoctorData = async () => {

        try {

            setLoading(true);

            const tableSchema = '';

            const tableName = 'users';

            const conditions = { id: id };

            const orderBy = 'id DESC';

            const search = {};

            const pagination = {};

            const margedata = [

                {

                    target_table: 'doctor_experience_education',

                    target_column: 'user_id',

                    target_value: 'id',

                    target_label: 'doctor_experience_education'

                },

                {

                    target_table: 'doctor_specialities',

                    target_column: 'doctor_id',

                    target_value: 'id',

                    target_label: 'doctor_specialities'

                },

                {

                    target_table: 'user_packages',

                    target_column: 'user_id',

                    target_value: 'id',

                    target_label: 'user_packages',

                    margedata: [

                        {

                            target_table: 'packages',

                            target_column: 'id',

                            target_value: 'package_id',

                            target_label: 'packages'

                        }

                    ]

                }

            ];

            const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);

            if (response.data && response.data.length > 0) {

                console.log("doctor data get show details:", response.data[0]);

                setDoctorData(response.data[0]);

            } else {

                toast.error('Hospital not found');

                navigate('/superadmin/hospitals');

            }

        } catch (error) {

            console.error('Error fetching hospital data:', error);

            toast.error('Failed to load hospital data');

        } finally {

            setLoading(false);

        }

    };

    const fetchInvoices = async () => {

        try {

            setInvoicesLoading(true);

            const tableSchema = '';

            const tableName = 'invoices';

            const conditions = { client: id };

            const orderBy = 'id DESC';

            const search = '';

            const pagination = JSON.stringify({ page, limit });

            const margedata = '';

            const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);

            if (response.data) {

                setInvoices(response.data);

                setTotalPages(Math.ceil(response.pagination?.total / limit) || 0);

            } else {

                setInvoices([]);

            }

        } catch (error) {

            console.error('Error fetching invoices:', error);

            toast.error('Failed to load invoices');

        } finally {

            setInvoicesLoading(false);

        }

    };

    const fetchMarketingTasks = async () => {

        try {

            setTasksLoading(true);

            const tableSchema = '';

            const tableName = 'posts';

            const conditions = { doctor_id: id };

            const orderBy = 'id DESC';

            const search = '';

            const pagination = JSON.stringify({ page, limit });

            const margedata = '';

            const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);

            if (response.data) {

                setMarketingTasks(response.data);

                setTotalPages(Math.ceil(response.pagination?.total / limit) || 0);

            } else {

                setMarketingTasks([]);

            }

        } catch (error) {

            console.error('Error fetching marketing tasks:', error);

            // Don't show error toast if table doesn't exist

            if (!error.message?.includes('does not exist')) {

                toast.error('Failed to load marketing tasks');

            }

            setMarketingTasks([]);

        } finally {

            setTasksLoading(false);

        }

    };

    const fetchAppointments = async () => {

        try {

            setAppointmentsLoading(true);

            const tableSchema = '';

            const tableName = 'appointments';

            const conditions = { doctor_id: id };

            const orderBy = 'id DESC';

            const search = '';

            const pagination = JSON.stringify({ page, limit });

            const margedata = [
                {
                    target_table: 'users',
                    target_column: 'id',
                    target_value: 'patient_id',
                    target_label: 'patient'
                }
            ];

            const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);

            if (response.data) {

                setAppointments(response.data);

                setTotalPages(Math.ceil(response.pagination?.total / limit) || 0);

            } else {

                setAppointments([]);

            }

        } catch (error) {

            console.error('Error fetching appointments:', error);

            setAppointments([]);

        } finally {

            setAppointmentsLoading(false);

        }

    };

    const fetchPackages = async () => {

        try {

            setPackagesLoading(true);

            const tableSchema = '';

            const tableName = 'packages';

            const conditions = {};

            const orderBy = 'id DESC';

            const search = '';

            const pagination = '';

            const margedata = '';

            const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);

            if (response.data) {

                // Filter to show package assigned to this doctor

                const doctorPackage = doctorData?.packages?.[0];

                if (doctorPackage) {

                    setPackages([doctorPackage]);

                } else {

                    setPackages([]);

                }

            } else {

                setPackages([]);

            }

        } catch (error) {

            console.error('Error fetching packages:', error);

            setPackages([]);

        } finally {

            setPackagesLoading(false);

        }

    };

    const handleTabSelect = (key) => {

        setActiveTab(key);

        setPage(1); // Reset page when changing tabs

        setSearchParams({ tab: key });

    };

    const handleAddInvoice = () => {

        setInvoiceMode('add');

        setSelectedInvoice(null);

        setShowInvoiceModal(true);

    };

    const handleViewInvoice = (invoice) => {

        console.log("invoice get show details:", invoice);

        setInvoiceMode('view');

        setSelectedInvoice(invoice);

        setShowInvoiceModal(true);

    };

    const handleEditInvoice = (invoice) => {

        setInvoiceMode('edit');

        setSelectedInvoice(invoice);

        setShowInvoiceModal(true);

    };

    const refreshInvoices = () => {

        fetchInvoices();

    };

    // Handler for opening media modal (poster or banner)

    const handleOpenMediaModal = (type) => {

        setMediaType(type);

        setMediaFormData({

            id: null,

            type: type,

            name: '',

            description: '',

            date: '',

            referenceImage: null,

            referenceImage_url: '',

            referenceImage_preview: null,

            uploadFile: null,

            uploadFile_url: '',

            uploadFile_preview: null

        });

        setShowMediaModal(true);

    };

    // Handler for viewing media details

    const handleViewMedia = (media) => {

        console.log("View media:", media);

        // You can implement a view modal or navigate to a detail page

        toast.info('View functionality - to be implemented');

    };

    // Handler for editing media

    const handleEditMedia = (media) => {

        console.log("Edit media:", media);

        setMediaType(media.type || 'poster');

        setMediaFormData({

            id: media.id,

            type: media.type || 'poster',

            name: media.title || '',

            description: media.description || '',

            date: media.date || '',

            referenceImage: media.referenceImage || null,

            referenceImage_url: media.referenceImage_url || '',

            referenceImage_preview: null,

            uploadFile: media.image || null,

            uploadFile_url: media.image_url || '',

            uploadFile_preview: null

        });

        setShowMediaModal(true);

    };

    // Handler for closing media modal

    const handleCloseMediaModal = () => {

        setShowMediaModal(false);

        setMediaType('');

        setMediaFormData({

            id: null,

            type: '',

            name: '',

            description: '',

            date: '',

            referenceImage: null,

            referenceImage_url: '',

            referenceImage_preview: null,

            uploadFile: null,

            uploadFile_url: '',

            uploadFile_preview: null

        });

    };

    // Handler for form input changes

    const handleMediaFormChange = async (e) => {

        const { name, value, files } = e.target;

        if (files && files.length > 0) {

            try {

                setTasksLoading(true);

                const uploadedFile = await OneKlicksFileSDK.uploadFile('marketing-media', 'public', files[0]);

                console.log("uploadedFile", uploadedFile);

                if (uploadedFile && uploadedFile.file) {

                    if (name === 'referenceImage') {

                        setMediaFormData(prev => ({

                            ...prev,

                            referenceImage: uploadedFile.file.id,

                            referenceImage_url: uploadedFile.file.root + '/' + uploadedFile.file.fileName,

                            referenceImage_preview: files[0]

                        }));

                        toast.success('Reference image uploaded successfully');

                    } else if (name === 'uploadFile') {

                        setMediaFormData(prev => ({

                            ...prev,

                            uploadFile: uploadedFile.file.id,

                            uploadFile_url: uploadedFile.file.root + '/' + uploadedFile.file.fileName,

                            uploadFile_preview: files[0]

                        }));

                        toast.success('File uploaded successfully');

                    }

                } else {

                    toast.error('Failed to upload file');

                }

            } catch (error) {

                console.error("Error uploading file:", error);

                toast.error("Failed to upload file");

            } finally {

                setTasksLoading(false);

            }

        } else {

            setMediaFormData(prev => ({

                ...prev,

                [name]: value

            }));

        }

    };

    // Handler for form submission

    const handleMediaFormSubmit = async (e) => {

        e.preventDefault();

        // Validate form

        if (!mediaFormData.name || !mediaFormData.description || !mediaFormData.date) {

            toast.error('Please fill in all required fields');

            return;

        }

        try {

            const payload = {

                title: mediaFormData.name,

                description: mediaFormData.description,

                date: mediaFormData.date,

                type: mediaType,

                doctor_id: id,

                status: 'Pending',

            };

            // Add file IDs if they were uploaded

            if (mediaFormData.referenceImage) {

                payload.referenceImage = mediaFormData.referenceImage;

                payload.referenceImage_url = mediaFormData.referenceImage_url;

            }

            if (mediaFormData.uploadFile) {

                payload.image = mediaFormData.uploadFile;

                payload.image_url = mediaFormData.uploadFile_url;

            }

            console.log("Submitting payload:", payload);

            let response;

            // Check if we're editing or creating

            if (mediaFormData.id) {

                // Update existing media

                response = await oneKlicks.update('', 'posts', payload, { id: mediaFormData.id });

                if (response.success) {

                    toast.success(`${mediaType === 'poster' ? 'Poster' : 'Banner'} updated successfully!`);

                } else {

                    toast.error(`Failed to update ${mediaType}`);

                }

            } else {

                // Create new media

                response = await oneKlicks.create('', 'posts', payload, {});

                if (response.success) {

                    toast.success(`${mediaType === 'poster' ? 'Poster' : 'Banner'} added successfully!`);

                } else {

                    toast.error(`Failed to add ${mediaType}`);

                }

            }

            if (response.success) {

                handleCloseMediaModal();

                fetchMarketingTasks();

            }

        } catch (error) {

            console.error('Error saving media:', error);

            toast.error(`Failed to save ${mediaType}`);

        }

    };

    const getStatusBadge = (status) => {

        console.log("status get show details:", status);

        const statusMap = {

            '1:': 'success',

            'paid': 'success',

            'unpaid': 'danger',

            'pending': 'warning',

            'cancelled': 'secondary',

            'completed': 'success',

            'confirmed': 'info',

            'active': 'success',

            'inactive': 'secondary',

            'expired': 'danger'

        };

        if (!status) return <Badge bg="secondary">-</Badge>;

        // Convert to string and lowercase for lookup

        const statusKey = String(status).toLowerCase().replace(/_/g, ' ').trim();

        // Format display text: replace underscores with spaces and capitalize first letter of each word

        const displayText = String(status)

            .replace(/_/g, ' ')

            .split(' ')

            .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())

            .join(' ');

        return <Badge bg={statusMap[statusKey] || 'secondary'}>{displayText}</Badge>;

    };

    const formatDate = (dateString) => {

        if (!dateString) return '-';

        return new Date(dateString).toLocaleDateString('en-IN', {

            year: 'numeric',

            month: 'short',

            day: 'numeric'

        });

    };

    const formatCurrency = (amount) => {

        if (!amount) return '₹0';

        return `₹${parseFloat(amount).toLocaleString('en-IN')}`;

    };

    if (loading) {

        return <Preloader />;

    }

    if (!doctorData) {

        return (

            <div className="text-center p-5">

                <h4>{userRoleLabel} not found</h4>

                <Button variant="primary" onClick={() => navigate(isHospital ? '/superadmin/hospitals' : '/superadmin/doctors')}>

                    Back to {userRoleLabel}s

                </Button>

            </div>

        );

    }

    // Safe JSON parse utility (in case it's not already defined)

    const safeJSONParse = (value) => {

        try {

            return typeof value === "string" ? JSON.parse(value) : value;

        } catch {

            return null;

        }

    };

    // Extract the most recent education info from the doctor data

    const getEducationInfo = () => {

        const educationData = doctorData?.doctor_experience_education?.[0]?.educations;

        if (!educationData) return null;

        const educations = safeJSONParse(educationData);

        if (!Array.isArray(educations) || educations.length === 0) return null;

        // Sort by start_date or ending_date (optional)

        const sorted = [...educations].sort((a, b) => {

            const dateA = new Date(a.ending_date || a.start_date || 0);

            const dateB = new Date(b.ending_date || b.start_date || 0);

            return dateB - dateA; // latest first

        });

        return sorted[0]; // Return latest education

    };

    return (

        <div className="dc-haslayout dc-dbsectionspace">

            <div className="container-fluid py-3">

                {/* Hospital Profile Header */}

                <Card className="mb-4">

                    <Card.Body>

                        <Row>

                            <Col md={3} className="text-center">

                                {doctorData.profile_photo ? (

                                    <ImageShow

                                        url={doctorData.profile_photo_url}

                                        style={{

                                            width: '200px',

                                            height: '200px',

                                            borderRadius: '50%',

                                            objectFit: 'cover',

                                            border: '4px solid #f0f0f0'

                                        }}

                                    />

                                ) : (

                                    <div

                                        style={{

                                            width: '200px',

                                            height: '200px',

                                            borderRadius: '50%',

                                            backgroundColor: '#e9ecef',

                                            display: 'flex',

                                            alignItems: 'center',

                                            justifyContent: 'center',

                                            fontSize: '48px',

                                            fontWeight: 'bold',

                                            color: '#6c757d',

                                            margin: '0 auto'

                                        }}

                                    >

                                        {doctorData.display_name?.charAt(0) || 'H'}

                                    </div>

                                )}

                                <div className="mt-3">

                                    {doctorData.status === '1' ? <Badge bg="success">Active</Badge> : <Badge bg="danger">Inactive</Badge>}

                                </div>

                            </Col>

                            <Col md={9}>

                                <div className="d-flex justify-content-between align-items-center mb-3">

                                    <h3 className="mb-0 text-dark font-weight-bold">

                                        {formatDoctorName(doctorData.first_name, doctorData.last_name, doctorData.display_name)}

                                    </h3>

                                    <Button variant="primary" size="md" onClick={handleOpenEditDoctorModal} style={{ height: '40px', padding: '0 20px', fontSize: '14px', fontWeight: '600', borderRadius: '8px', backgroundColor: '#2563eb', borderColor: '#2563eb', boxShadow: '0 4px 6px -1px rgba(37, 99, 235, 0.2)' }}>

                                        <i className="fa fa-edit me-2"></i>Edit Profile Details

                                    </Button>

                                </div>

                                {doctorData.subheading && (

                                    <p className="text-muted mb-3">{doctorData.subheading}</p>

                                )}

                                <div className="dc-tags mb-3">

                                    <DoctorSpecialities doctorId={doctorData.id} service={true} data={[]} type="full" />

                                </div>

                                <Row className="mb-3">

                                    <Col md={6}>

                                        {doctorData.email && (

                                            <div className="mb-2" style={{ display: 'flex', alignItems: 'center', justifyContent: 'left', gap: '5px' }}>

                                                <FaEnvelope className="me-2 text-primary" />

                                                <strong>&nbsp;Email:&nbsp;</strong> {doctorData.email}

                                            </div>

                                        )}

                                        {doctorData.phone && (

                                            <div className="mb-2" style={{ display: 'flex', alignItems: 'center', justifyContent: 'left', gap: '5px' }}>

                                                <FaPhone className="me-2 text-primary" />

                                                <strong>Phone:</strong> {doctorData.phone}

                                            </div>

                                        )}

                                    </Col>

                                    <Col md={6}>

                                        {doctorData.starting_price && (

                                            <div className="mb-2" style={{ display: 'flex', alignItems: 'center', justifyContent: 'left', gap: '5px' }}>

                                                <FaMoneyBillWave className="me-2 text-success" />

                                                <strong>Starting Price:</strong> {formatCurrency(doctorData.starting_price)}

                                            </div>

                                        )}

                                        {/* Education */}

                                        {(() => {

                                            const education = getEducationInfo();

                                            if (education) {

                                                return (

                                                    <div className="dc-education" style={{

                                                        fontSize: '12px',

                                                        color: '#666',

                                                        marginBottom: '5px',

                                                        display: 'flex',

                                                        alignItems: 'center',

                                                        gap: '5px'

                                                    }}>

                                                        <i className="fas fa-graduation-cap" style={{ color: '#3b82f6' }}></i>

                                                        <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: '150px' }}>{education?.degree_title || 'Education'}</span>

                                                        {/* {education?.institute_name && (

                                                            <span style={{ color: '#999' }}>• {education.institute_name}</span>

                                                        )} */}

                                                    </div>

                                                );

                                            }

                                            return null;

                                        })()}

                                        {doctorData.rating && (

                                            <div className="mb-2" style={{ display: 'flex', alignItems: 'center', justifyContent: 'left', gap: '5px' }}>

                                                <FaStar className="me-2 text-warning" />

                                                <strong>Rating:</strong> {doctorData.rating}/5

                                            </div>

                                        )}

                                    </Col>

                                </Row>

                                {doctorData.user_packages?.[0]?.packages?.[0] && (

                                    <div className="alert alert-info mb-0">

                                        <strong>Active Package:</strong> {doctorData.user_packages[0]?.packages[0]?.name} - {doctorData.user_packages[0]?.packages[0]?.description}

                                    </div>

                                )}

                            </Col>

                        </Row>

                    </Card.Body>

                </Card>

                {/* Tabs Section */}

                <Card>

                    <Card.Body>

                        <Tab.Container activeKey={activeTab} onSelect={handleTabSelect}>

                            <style>{`
                                .custom-nav-tabs {
                                    flex-wrap: nowrap;
                                    overflow-x: auto;
                                    overflow-y: hidden;
                                    white-space: nowrap;
                                    -webkit-overflow-scrolling: touch;
                                    border-bottom: 1px solid #e2e8f0;
                                    scrollbar-width: none; /* Firefox */
                                    -ms-overflow-style: none; /* IE and Edge */
                                }
                                .custom-nav-tabs::-webkit-scrollbar {
                                    display: none; /* Chrome, Safari and Opera */
                                }

                                .custom-nav-tabs .nav-link {
                                    color: #475569 !important;
                                    font-weight: 500;
                                    border: none;
                                    border-bottom: 2px solid transparent;
                                    padding: 10px 16px;
                                    font-size: 14px;
                                    transition: all 0.2s ease-in-out;
                                    white-space: nowrap;
                                }

                                .custom-nav-tabs .nav-link:hover {
                                    color: #2563eb !important;
                                    border-bottom-color: #cbd5e1;
                                }

                                .custom-nav-tabs .nav-link.active {
                                    color: #2563eb !important;
                                    font-weight: 600;
                                    border: none;
                                    border-bottom: 3px solid #2563eb !important;
                                    background-color: transparent !important;
                                }
                            `}</style>

                            <div className="d-flex align-items-center mb-4 border-bottom position-relative">
                                <button 
                                    type="button" 
                                    className="btn btn-light shadow-sm me-2 d-flex align-items-center justify-content-center"
                                    onClick={() => scrollTabs('left')}
                                    style={{ 
                                        width: '36px', 
                                        height: '36px', 
                                        borderRadius: '50%',
                                        border: '1px solid #e2e8f0',
                                        backgroundColor: '#ffffff',
                                        color: '#475569',
                                        cursor: 'pointer',
                                        transition: 'all 0.2s',
                                        zIndex: 10
                                    }}
                                >
                                    <i className="fas fa-chevron-left" style={{ fontSize: '13px' }}></i>
                                </button>

                                <div className="flex-grow-1" style={{ overflow: 'hidden' }}>
                                    <Nav variant="tabs" ref={tabsRef} className="custom-nav-tabs" style={{ borderBottom: 'none' }}>

                                        <Nav.Item>

                                            <Nav.Link eventKey="overview">Overview</Nav.Link>

                                        </Nav.Item>

                                        <Nav.Item>

                                            <Nav.Link eventKey="invoices">Invoices</Nav.Link>

                                        </Nav.Item>

                                        <Nav.Item>

                                            <Nav.Link eventKey="appointments">Appointments</Nav.Link>

                                        </Nav.Item>

                                        <Nav.Item>

                                            <Nav.Link eventKey="marketing">Postings & Banners</Nav.Link>

                                        </Nav.Item>

                                        <Nav.Item>

                                            <Nav.Link eventKey="packages">Package Details</Nav.Link>

                                        </Nav.Item>

                                        <Nav.Item>

                                            <Nav.Link eventKey="services">Specialities & Services</Nav.Link>

                                        </Nav.Item>

                                        <Nav.Item>

                                            <Nav.Link eventKey="details">Additional Details</Nav.Link>

                                        </Nav.Item>

                                        <Nav.Item>

                                            <Nav.Link eventKey="account_settings">Account Settings</Nav.Link>

                                        </Nav.Item>

                                        <Nav.Item>

                                            <Nav.Link eventKey="appointment_settings">Appointment Settings</Nav.Link>

                                        </Nav.Item>

                                        <Nav.Item>

                                            <Nav.Link eventKey="profile_settings">Profile Settings</Nav.Link>

                                        </Nav.Item>

                                        <Nav.Item>

                                            <Nav.Link eventKey="logs">Update Logs</Nav.Link>

                                        </Nav.Item>

                                    </Nav>
                                </div>

                                <button 
                                    type="button" 
                                    className="btn btn-light shadow-sm ms-2 d-flex align-items-center justify-content-center"
                                    onClick={() => scrollTabs('right')}
                                    style={{ 
                                        width: '36px', 
                                        height: '36px', 
                                        borderRadius: '50%',
                                        border: '1px solid #e2e8f0',
                                        backgroundColor: '#ffffff',
                                        color: '#475569',
                                        cursor: 'pointer',
                                        transition: 'all 0.2s',
                                        zIndex: 10
                                    }}
                                >
                                    <i className="fas fa-chevron-right" style={{ fontSize: '13px' }}></i>
                                </button>
                            </div>

                            <Tab.Content>

                                {/* Overview Tab */}

                                <Tab.Pane eventKey="overview">

                                    <Row>

                                        <Col md={12}>

                                            <h5 className="mb-3">About Doctor</h5>

                                            {doctorData.description ? (

                                                <p>{doctorData.description}</p>

                                            ) : (

                                                <p className="text-muted">No description available.</p>

                                            )}

                                        </Col>

                                    </Row>

                                    <Row className="mt-4">

                                        <Col md={4}>

                                            <Card className="text-center mb-3">

                                                <Card.Body>

                                                    <h6 className="text-muted">Total Appointments</h6>

                                                    <h3 className="mb-0">-</h3>

                                                </Card.Body>

                                            </Card>

                                        </Col>

                                        <Col md={4}>

                                            <Card className="text-center mb-3">

                                                <Card.Body>

                                                    <h6 className="text-muted">Total Revenue</h6>

                                                    <h3 className="mb-0">-</h3>

                                                </Card.Body>

                                            </Card>

                                        </Col>

                                        <Col md={4}>

                                            <Card className="text-center mb-3">

                                                <Card.Body>

                                                    <h6 className="text-muted">Active Since</h6>

                                                    <h3 className="mb-0">{formatDate(doctorData.created_at)}</h3>

                                                </Card.Body>

                                            </Card>

                                        </Col>

                                    </Row>

                                    {doctorData.staff && doctorData.staff.length > 0 && (

                                        <Row className="mt-4">

                                            <Col md={12}>

                                                <h5 className="mb-3">Staff Information</h5>

                                                <Table striped bordered hover>

                                                    <thead>

                                                        <tr>

                                                            <th>Name</th>

                                                            <th>Position</th>

                                                            <th>Email</th>

                                                            <th>Phone</th>

                                                        </tr>

                                                    </thead>

                                                    <tbody>

                                                        {doctorData.staff.map((staff, index) => (

                                                            <tr key={index}>

                                                                <td>{staff.first_name} {staff.last_name}</td>

                                                                <td>{staff.position || '-'}</td>

                                                                <td>{staff.email || '-'}</td>

                                                                <td>{staff.phone || '-'}</td>

                                                            </tr>

                                                        ))}

                                                    </tbody>

                                                </Table>

                                            </Col>

                                        </Row>

                                    )}

                                </Tab.Pane>

                                {/* Invoices Tab */}

                                <Tab.Pane eventKey="invoices">

                                    <div className="d-flex justify-content-between align-items-center mb-3">

                                        <h5 className="mb-0">Invoices</h5>

                                        <Button variant="primary" onClick={handleAddInvoice}>

                                            + Add Invoice

                                        </Button>

                                    </div>

                                    {invoicesLoading ? (

                                        <div className="text-center p-5">

                                            <Spinner animation="border" />

                                        </div>

                                    ) : invoices.length > 0 ? (

                                        <>

                                            <Table striped bordered hover responsive>

                                                <thead>

                                                    <tr>

                                                        <th>Invoice #</th>

                                                        <th>Type</th>

                                                        <th>Amount</th>

                                                        <th>Due Date</th>

                                                        <th>Status</th>

                                                        <th>Actions</th>

                                                    </tr>

                                                </thead>

                                                <tbody>

                                                    {invoices.map((invoice) => (

                                                        <tr key={invoice.id}>

                                                            <td>#{invoice.invoice_number || invoice.id}</td>

                                                            <td>{invoice.invoiceType || 'Invoice'}</td>

                                                            <td>{formatCurrency(invoice.total_amount || invoice.amount)}</td>

                                                            <td>{formatDate(invoice.dueDate)}</td>

                                                            <td>{getStatusBadge(invoice.status || 'Pending')}</td>

                                                            <td>

                                                                <Button

                                                                    variant="info"

                                                                    size="sm"

                                                                    className="me-2"

                                                                    onClick={() => handleViewInvoice(invoice)}

                                                                >

                                                                    View

                                                                </Button>

                                                                <Button

                                                                    variant="warning"

                                                                    size="sm"

                                                                    onClick={() => handleEditInvoice(invoice)}

                                                                >

                                                                    Edit

                                                                </Button>

                                                            </td>

                                                        </tr>

                                                    ))}

                                                </tbody>

                                            </Table>

                                            {totalPages > 1 && (

                                                <Paginationnew

                                                    currentPage={page}

                                                    totalPages={totalPages}

                                                    onPageChange={setPage}

                                                />

                                            )}

                                        </>

                                    ) : (

                                        <div className="text-center p-5">

                                            <p className="text-muted">No invoices found for this doctor.</p>

                                            <Button variant="primary" onClick={handleAddInvoice}>

                                                Create First Invoice

                                            </Button>

                                        </div>

                                    )}

                                </Tab.Pane>

                                {/* Appointments Tab */}

                                <Tab.Pane eventKey="appointments">

                                    <h5 className="mb-3">Appointments</h5>

                                    {appointmentsLoading ? (

                                        <div className="text-center p-5">

                                            <Spinner animation="border" />

                                        </div>

                                    ) : appointments.length > 0 ? (

                                        <>

                                            <Table striped bordered hover responsive>

                                                <thead>

                                                    <tr>

                                                        <th>Date & Time</th>

                                                        <th>Patient</th>

                                                        <th>Type</th>

                                                        <th>Status</th>

                                                        <th>Amount</th>

                                                    </tr>

                                                </thead>

                                                <tbody>

                                                    {appointments.map((appointment) => (

                                                        <tr key={appointment.id}>

                                                            <td>{formatDate(appointment.appointment_date)} {appointment.appointment_time}</td>

                                                            <td>

                                                                {appointment.patient?.[0] ?

                                                                    `${appointment.patient[0].first_name} ${appointment.patient[0].last_name}`

                                                                    : '-'

                                                                }

                                                            </td>

                                                            <td>{appointment.appointment_type || 'General'}</td>

                                                            <td>{getStatusBadge(appointment.status || 'Pending')}</td>

                                                            <td>{formatCurrency(appointment.amount)}</td>

                                                        </tr>

                                                    ))}

                                                </tbody>

                                            </Table>

                                            {totalPages > 1 && (

                                                <Paginationnew

                                                    currentPage={page}

                                                    totalPages={totalPages}

                                                    onPageChange={setPage}

                                                />

                                            )}

                                        </>

                                    ) : (

                                        <div className="text-center p-5">

                                            <p className="text-muted">No appointments found for this doctor.</p>

                                        </div>

                                    )}

                                </Tab.Pane>

                                {/* Marketing Tasks Tab */}

                                <Tab.Pane eventKey="marketing">

                                    <div className="mb-4">

                                        <MonthlyPostingPlan userdata={doctorData} />

                                    </div>

                                    <hr className="my-4" style={{ borderTop: '2px dashed #e2e8f0' }} />

                                    <div className="d-flex justify-content-between align-items-center mb-3">

                                        <h5 className="mb-0 text-dark font-weight-bold" style={{ fontSize: '18px' }}>Individual Banner & Poster Logs</h5>

                                        <div className="d-flex align-items-center gap-2">

                                            <Button variant="primary" onClick={() => handleOpenMediaModal('poster')} style={{ height: '36px', fontSize: '13px', fontWeight: '600' }}>

                                                + Add Posters

                                            </Button>

                                            <Button variant="primary" onClick={() => handleOpenMediaModal('generatewithai')} style={{ height: '36px', fontSize: '13px', fontWeight: '600' }}>

                                                + Generate

                                            </Button>

                                        </div>

                                    </div>

                                    {tasksLoading ? (

                                        <div className="text-center p-5">

                                            <Spinner animation="border" />

                                        </div>

                                    ) : marketingTasks.length > 0 ? (

                                        <>

                                            <Table striped bordered hover responsive>

                                                <thead>

                                                    <tr>

                                                        <th>ID</th>

                                                        <th>Details</th>

                                                        <th>Image</th>

                                                        <th>Status</th>

                                                        <th>Actions</th>

                                                    </tr>

                                                </thead>

                                                <tbody>

                                                    {marketingTasks.map((task) => (

                                                        <tr key={task.id}>

                                                            <td>#{task.id}</td>

                                                            <td>{task.title || 'General'}</td>

                                                            <td>

                                                                <ImageShow

                                                                    url={task.image_url}

                                                                    width={40}

                                                                    height={40}

                                                                    alt={task.title}

                                                                    style={{ width: 40, height: 40 }}

                                                                />

                                                            </td>

                                                            <td>{getStatusBadge(task.status || 'Pending')}</td>

                                                            <td>

                                                                <Button

                                                                    variant="info"

                                                                    size="sm"

                                                                    className="me-2"

                                                                    onClick={() => handleViewMedia(task)}

                                                                >

                                                                    View

                                                                </Button>

                                                            </td>

                                                            <td>

                                                                <Button

                                                                    variant="warning"

                                                                    size="sm"

                                                                    onClick={() => handleEditMedia(task)}

                                                                >

                                                                    Edit

                                                                </Button>

                                                            </td>

                                                        </tr>

                                                    ))}

                                                </tbody>

                                            </Table>

                                            {totalPages > 1 && (

                                                <Paginationnew

                                                    currentPage={page}

                                                    totalPages={totalPages}

                                                    onPageChange={setPage}

                                                />

                                            )}

                                        </>

                                    ) : (

                                        <div className="text-center p-5">

                                            <p className="text-muted">No marketing tasks found for this doctor.</p>

                                        </div>

                                    )}

                                </Tab.Pane>

                                {/* Packages Tab */}

                                <Tab.Pane eventKey="packages">

                                    <h5 className="mb-3">Package Details</h5>

                                    {packagesLoading ? (

                                        <div className="text-center p-5">

                                            <Spinner animation="border" />

                                        </div>

                                    ) : doctorData.packages && doctorData.packages.length > 0 ? (

                                        <Row>

                                            {doctorData.packages.map((pkg) => (

                                                <Col md={12} key={pkg.id}>

                                                    <Card className="mb-3">

                                                        <Card.Body>

                                                            <Row>

                                                                <Col md={8}>

                                                                    <h4>{pkg.name}</h4>

                                                                    <p className="text-muted">{pkg.description}</p>

                                                                    <div className="mt-3">

                                                                        <strong>Features:</strong>

                                                                        <ul className="mt-2">

                                                                            {pkg.features && JSON.parse(pkg.features).map((feature, idx) => (

                                                                                <li key={idx}>{feature}</li>

                                                                            ))}

                                                                        </ul>

                                                                    </div>

                                                                    {pkg.duration && (

                                                                        <div className="mt-2">

                                                                            <strong>Duration:</strong> {pkg.duration} days

                                                                        </div>

                                                                    )}

                                                                </Col>

                                                                <Col md={4} className="text-end">

                                                                    <h3 className="text-primary">{formatCurrency(pkg.price)}</h3>

                                                                    {getStatusBadge(pkg.status || 'Active')}

                                                                </Col>

                                                            </Row>

                                                        </Card.Body>

                                                    </Card>

                                                </Col>

                                            ))}

                                        </Row>

                                    ) : (

                                        <div className="text-center p-5">

                                            <p className="text-muted">No package assigned to this doctor.</p>

                                        </div>

                                    )}

                                </Tab.Pane>

                                {/* Specialities & Services Tab */}

                                <Tab.Pane eventKey="services">

                                    <div className="d-flex justify-content-between align-items-center mb-4">

                                        <div>

                                            <h5 className="mb-1 text-dark font-weight-bold">Manage Specialities & Services</h5>

                                            <p className="text-muted mb-0" style={{ fontSize: '13px' }}>Configure the medical services, consulting fees, and clinical descriptions offered by this doctor.</p>

                                        </div>

                                        <div className="d-flex gap-2">

                                            <Button

                                                variant="primary"

                                                onClick={handleAddDocSpeciality}

                                                disabled={servicesLoading || servicesSaving}

                                                style={{ borderRadius: '8px', padding: '8px 20px', fontWeight: '600', backgroundColor: '#2563eb', borderColor: '#2563eb', boxShadow: '0 4px 6px -1px rgba(37, 99, 235, 0.2)' }}

                                            >

                                                <i className="fa fa-plus me-1"></i> Add Speciality

                                            </Button>

                                            <Button

                                                variant="success"

                                                onClick={handleSaveDocServices}

                                                disabled={servicesLoading || servicesSaving}

                                            >

                                                {servicesSaving ? (

                                                    <>

                                                        <Spinner animation="border" size="sm" className="me-2" />

                                                        Saving...

                                                    </>

                                                ) : (

                                                    <>

                                                        <i className="fa fa-save me-1"></i> Save Changes

                                                    </>

                                                )}

                                            </Button>

                                        </div>

                                    </div>

                                    {servicesLoading ? (

                                        <div className="text-center p-5">

                                            <Spinner animation="border" variant="primary" />

                                            <p className="mt-2 text-muted">Loading doctor's services...</p>

                                        </div>

                                    ) : docSpecialities.length > 0 ? (

                                        docSpecialities.map((spec) => (

                                            <Card key={spec.id} className="mb-4 border shadow-sm" style={{ borderRadius: '12px', overflow: 'hidden' }}>

                                                <Card.Header className="bg-light d-flex justify-content-between align-items-center py-3 px-4 border-bottom">

                                                    <div className="d-flex align-items-center gap-3" style={{ flex: 1 }}>

                                                        <div className="d-flex align-items-center justify-content-center rounded-3" style={{ width: '40px', height: '40px', backgroundColor: '#eff6ff', color: '#2563eb' }}>

                                                            <i className="fa fa-stethoscope" style={{ fontSize: '18px' }}></i>

                                                        </div>

                                                        <Form.Select

                                                            value={String(spec.speciality)}

                                                            onChange={(e) => handleDocSpecialityChange(spec.id, e.target.value)}

                                                            style={{ maxWidth: '300px', fontWeight: '600', fontSize: '15px' }}

                                                        >

                                                            {masterSpecialities.map(opt => (

                                                                <option key={opt.id} value={String(opt.id)}>

                                                                    {opt.name.replace(/&amp;/g, '&')}

                                                                </option>

                                                            ))}

                                                        </Form.Select>

                                                    </div>

                                                    <div className="d-flex gap-2">

                                                        <Button

                                                            variant="outline-primary"

                                                            size="sm"

                                                            onClick={() => handleAddDocService(spec.id)}

                                                            style={{ fontSize: '13px', fontWeight: '600', borderRadius: '8px', color: '#2563eb', borderColor: '#2563eb', backgroundColor: '#ffffff' }}

                                                        >

                                                            <i className="fa fa-plus me-1"></i> Add Service

                                                        </Button>

                                                        <Button

                                                            variant="outline-danger"

                                                            size="sm"

                                                            onClick={() => handleRemoveDocSpeciality(spec.id)}

                                                        >

                                                            <i className="fa fa-trash"></i>

                                                        </Button>

                                                    </div>

                                                </Card.Header>

                                                <Card.Body className="p-0">

                                                    {spec.services && spec.services.length > 0 ? (

                                                        spec.services.map((srv, index) => (

                                                            <div key={srv.id} className="p-3 px-4 border-bottom bg-white hover-bg-light transition-all" style={{ borderBottom: index === spec.services.length - 1 ? 'none' : '1px solid #dee2e6' }}>

                                                                <Row className="align-items-end g-3">

                                                                    <Col md={4}>

                                                                        <Form.Label className="text-muted font-weight-600 mb-1" style={{ fontSize: '11px', letterSpacing: '0.5px', textTransform: 'uppercase' }}>Service Name</Form.Label>

                                                                        <Form.Select

                                                                            value={srv.service ? String(srv.service) : ''}

                                                                            onChange={(e) => handleDocServiceChange(spec.id, srv.id, 'service', e.target.value)}

                                                                            required

                                                                        >

                                                                            <option value="">Choose Service</option>

                                                                            {masterServices

                                                                                .filter(s => String(s.speciality_id) === String(spec.speciality))

                                                                                .map(s => (

                                                                                    <option key={s.id} value={String(s.id)}>

                                                                                        {s.name.replace(/&amp;/g, '&')}

                                                                                    </option>

                                                                                ))

                                                                            }

                                                                        </Form.Select>

                                                                    </Col>

                                                                    <Col md={2}>

                                                                        <Form.Label className="text-muted font-weight-600 mb-1" style={{ fontSize: '11px', letterSpacing: '0.5px', textTransform: 'uppercase' }}>Price (₹)</Form.Label>

                                                                        <InputGroup>

                                                                            <InputGroup.Text>₹</InputGroup.Text>

                                                                            <Form.Control

                                                                                type="number"

                                                                                value={srv.price || ''}

                                                                                onChange={(e) => handleDocServiceChange(spec.id, srv.id, 'price', e.target.value)}

                                                                                placeholder="Fee"

                                                                                required

                                                                            />

                                                                        </InputGroup>

                                                                    </Col>

                                                                    <Col md={5}>

                                                                        <Form.Label className="text-muted font-weight-600 mb-1" style={{ fontSize: '11px', letterSpacing: '0.5px', textTransform: 'uppercase' }}>Description (Optional)</Form.Label>

                                                                        <Form.Control

                                                                            type="text"

                                                                            value={srv.description || ''}

                                                                            onChange={(e) => handleDocServiceChange(spec.id, srv.id, 'description', e.target.value)}

                                                                            placeholder="Brief description of clinical service..."

                                                                        />

                                                                    </Col>

                                                                    <Col md={1} className="d-flex justify-content-end pb-1">

                                                                        <Button

                                                                            variant="link"

                                                                            className="text-danger p-0"

                                                                            onClick={() => handleRemoveDocService(spec.id, srv.id)}

                                                                            title="Remove Service"

                                                                        >

                                                                            <i className="fa fa-trash-alt fs-5"></i>

                                                                        </Button>

                                                                    </Col>

                                                                </Row>

                                                            </div>

                                                        ))

                                                    ) : (

                                                        <div className="p-4 text-center bg-light border-top" style={{ backgroundColor: "#f8fafc" }}>

                                                            <p className="text-muted mb-3" style={{ fontSize: "14px" }}>No services added for this speciality yet.</p>

                                                            <div className="d-flex justify-content-center">

                                                                <Button

                                                                    variant="outline-primary"

                                                                    size="sm"

                                                                    onClick={() => handleAddDocService(spec.id)}

                                                                >

                                                                    <i className="fa fa-plus me-1"></i> Add First Service

                                                                </Button>

                                                            </div>

                                                        </div>

                                                    )}

                                                </Card.Body>

                                            </Card>

                                        ))

                                    ) : (

                                        <div className="text-center py-5 border bg-white shadow-sm" style={{ borderRadius: '16px', border: '1px dashed #cbd5e1' }}>

                                            <div className="mb-3 d-inline-flex align-items-center justify-content-center bg-light text-primary rounded-circle" style={{ width: '80px', height: '80px', backgroundColor: '#eff6ff' }}>

                                                <i className="fa fa-stethoscope" style={{ fontSize: '36px', color: '#2563eb' }}></i>

                                            </div>

                                            <h5 className="font-weight-bold text-dark mb-2">No Specialities Added Yet</h5>

                                            <p className="text-muted mb-4 mx-auto" style={{ fontSize: '14px', maxWidth: '400px' }}>Start defining the medical categories and custom services for this doctor to enable patient booking.</p>

                                            <div className="d-flex justify-content-center">

                                                <Button variant="primary" size="lg" onClick={handleAddDocSpeciality} style={{ borderRadius: '10px', padding: '10px 24px', fontWeight: '600', boxShadow: '0 4px 6px -1px rgba(37, 99, 235, 0.2)' }}>

                                                    <i className="fa fa-plus me-2"></i> Start Adding Specialities

                                                </Button>

                                            </div>

                                        </div>

                                    )}

                                    <div className="mt-4 p-3 bg-light rounded d-flex align-items-center gap-2 border" style={{ fontSize: '13px' }}>

                                        <i className="fa fa-info-circle text-primary"></i>

                                        <span className="text-muted">Changes will only be permanently stored in the database after clicking the <strong>Save Changes</strong> button on the top right.</span>

                                    </div>

                                </Tab.Pane>

                                {/* Additional Details Tab */}

                                <Tab.Pane eventKey="details">

                                    <h5 className="mb-3">Additional Information</h5>

                                    <Row>

                                        <Col md={6}>

                                            <Card className="mb-3">

                                                <Card.Header>

                                                    <strong>Personal Information</strong>

                                                </Card.Header>

                                                <Card.Body>

                                                    <p><strong>Gender:</strong> {doctorData.gendar || '-'}</p>

                                                    <p><strong>Date of Birth:</strong> {formatDate(doctorData.dob)}</p>

                                                    <p><strong>Blood Group:</strong> {doctorData.blood_group || '-'}</p>

                                                    <p><strong>Languages:</strong> {doctorData.languages || '-'}</p>

                                                </Card.Body>

                                            </Card>

                                        </Col>

                                        <Col md={6}>

                                            <Card className="mb-3">

                                                <Card.Header>

                                                    <strong>Professional Information</strong>

                                                </Card.Header>

                                                <Card.Body>

                                                    <p><strong>Registration Number:</strong> {doctorData.registration_number || '-'}</p>

                                                    <p><strong>Registration Year:</strong> {doctorData.registration_year || '-'}</p>

                                                    <p><strong>Council:</strong> {doctorData.council || '-'}</p>

                                                    <p><strong>Verified:</strong> {doctorData.verified ? 'Yes' : 'No'}</p>

                                                </Card.Body>

                                            </Card>

                                        </Col>

                                    </Row>

                                    {doctorData.address && (

                                        <Card className="mb-3">

                                            <Card.Header>

                                                <strong>Address Information</strong>

                                            </Card.Header>

                                            <Card.Body>

                                                <p><FaMapMarkerAlt className="me-2" />{doctorData.address}</p>

                                                {doctorData.city && <p><strong>City:</strong> {doctorData.city}</p>}

                                                {doctorData.state && <p><strong>State:</strong> {doctorData.state}</p>}

                                                {doctorData.pincode && <p><strong>Pincode:</strong> {doctorData.pincode}</p>}

                                            </Card.Body>

                                        </Card>

                                    )}

                                    <Card>

                                        <Card.Header>

                                            <strong>Account Information</strong>

                                        </Card.Header>

                                        <Card.Body>

                                            <p><strong>User ID:</strong> {doctorData.id}</p>

                                            <p><strong>User Type:</strong> {doctorData.type || 'Doctor'}</p>

                                            <p><strong>Created At:</strong> {formatDate(doctorData.created_at)}</p>

                                            <p><strong>Last Updated:</strong> {formatDate(doctorData.updated_at)}</p>

                                        </Card.Body>

                                    </Card>

                                </Tab.Pane>

                                {/* Logs Tab */}

                                <Tab.Pane eventKey="logs">

                                    <div className="d-flex justify-content-between align-items-center mb-4">

                                        <h5 className="mb-0 text-dark font-weight-bold">Profile Update & Activity Logs</h5>

                                        <Button variant="outline-secondary" size="sm" onClick={fetchActivityLogs}>

                                            <i className="fas fa-sync-alt me-1"></i> Refresh Logs

                                        </Button>

                                    </div>

                                    {logsLoading ? (

                                        <div className="text-center p-5">

                                            <Spinner animation="border" variant="primary" />

                                            <p className="mt-2 text-muted">Retrieving audit activity logs...</p>

                                        </div>

                                    ) : activityLogs && activityLogs.length > 0 ? (

                                        <>

                                            <div className="table-responsive">

                                                <Table hover className="align-middle">

                                                    <thead className="table-light">

                                                        <tr>

                                                            <th style={{ width: '20%' }}>Date & Time</th>

                                                            <th style={{ width: '15%' }}>Log Type</th>

                                                            <th style={{ width: '65%' }}>Details of Modification</th>

                                                        </tr>

                                                    </thead>

                                                    <tbody>

                                                        {activityLogs.map((log) => (

                                                            <tr key={log.id}>

                                                                <td className="text-muted font-weight-500" style={{ whiteSpace: 'nowrap', fontSize: '14px' }}>

                                                                    {new Date(log.created_at).toLocaleString('en-IN', {

                                                                        day: '2-digit',

                                                                        month: 'short',

                                                                        year: 'numeric',

                                                                        hour: '2-digit',

                                                                        minute: '2-digit',

                                                                        second: '2-digit',

                                                                        hour12: true

                                                                    })}

                                                                </td>

                                                                <td>

                                                                    <Badge bg="info" className="text-uppercase" style={{ fontSize: '11px', letterSpacing: '0.5px' }}>

                                                                        {log.activity_type || 'Update'}

                                                                    </Badge>

                                                                </td>

                                                                <td style={{ fontSize: '14px', lineHeight: '1.5', color: '#333' }}>

                                                                    {log.description}

                                                                </td>

                                                            </tr>

                                                        ))}

                                                    </tbody>

                                                </Table>

                                            </div>

                                            {totalPages > 1 && (

                                                <div className="d-flex justify-content-center mt-4">

                                                    <Paginationnew

                                                        currentPage={page}

                                                        totalPages={totalPages}

                                                        onPageChange={setPage}

                                                    />

                                                </div>

                                            )}

                                        </>

                                    ) : (

                                        <div className="text-center py-5 border rounded bg-light">

                                            <i className="fas fa-history text-muted mb-3" style={{ fontSize: '48px' }}></i>

                                            <p className="text-muted mb-0">No profile update activity logs recorded for this doctor.</p>

                                        </div>

                                    )}

                                </Tab.Pane>

                                <Tab.Pane eventKey="account_settings">
                                    <Row className="mt-2">
                                        <Col md={3}>
                                            <div className="d-flex flex-column gap-2 p-3 bg-light border rounded" style={{ minHeight: '400px' }}>
                                                <h6 className="text-muted text-uppercase font-size-sm mb-3 px-2" style={{ letterSpacing: '0.05em', fontWeight: 600 }}>Account Sections</h6>
                                                {[
                                                    "Security & Settings",
                                                    "Password",
                                                    "Email Notification",
                                                    "Social Account Details",
                                                    "Account Sharing",
                                                    "Bank Account Details",
                                                    "Seo Settings",
                                                    "Invoice Settings",
                                                    "Delete Account"
                                                ].map((tabName) => (
                                                    <button
                                                        key={tabName}
                                                        type="button"
                                                        className={`btn text-start py-2 px-3 rounded transition-all ${
                                                            accountTab === tabName 
                                                            ? 'btn-primary shadow-sm font-weight-bold' 
                                                            : 'btn-link text-dark hover-bg-light border-0'
                                                        }`}
                                                        style={{ 
                                                            fontSize: '14px', 
                                                            transition: 'all 0.2s',
                                                            backgroundColor: accountTab === tabName ? '#2563eb' : 'transparent',
                                                            color: accountTab === tabName ? '#fff' : '#334155'
                                                        }}
                                                        onClick={() => setAccountTab(tabName)}
                                                    >
                                                        {tabName}
                                                    </button>
                                                ))}
                                            </div>
                                        </Col>
                                        <Col md={9}>
                                            <div className="p-4 border rounded bg-white shadow-sm d-flex flex-column justify-content-between" style={{ minHeight: '500px' }}>
                                                <div>
                                                    {accountTab === "Security & Settings" && (
                                                        <SecuritySettings userId={id} />
                                                    )}
                                                    {accountTab === "Password" && (
                                                        <Password oldpassword={oldpassword} setOldpassword={setOldpassword} newpassword={newpassword} setNewpassword={setNewpassword} confirmpassword={confirmpassword} setConfirmpassword={setConfirmpassword} />
                                                    )}
                                                    {accountTab === "Email Notification" && (
                                                        <EmailNotification email={email} onEmailChange={setEmail} emailisvalid={emailisvalid} />
                                                    )}
                                                    {accountTab === "Social Account Details" && (
                                                        <SocialAccountDetails />
                                                    )}
                                                    {accountTab === "Delete Account" && (
                                                        <DeleteAccount formData={formData} setFormData={setFormData} />
                                                    )}
                                                    {accountTab === "Account Sharing" && (
                                                        <AccountSharing userId={id} />
                                                    )}
                                                    {accountTab === "Seo Settings" && (
                                                        <SeoSettings userId={id} doctorData={doctorData} onActivityLog={logAdminActivity} />
                                                    )}
                                                    {accountTab === "Invoice Settings" && (
                                                        <InvoiceSettings localInvoice={localInvoice} setLocalInvoice={setLocalInvoice} userId={id} />
                                                    )}
                                                    {accountTab === "Bank Account Details" && (
                                                        <BankAccountDetails userId={id} />
                                                    )}
                                                </div>

                                                {/* Save & Update Actions */}
                                                {["Password", "Email Notification", "Delete Account", "Invoice Settings"].includes(accountTab) && (
                                                    <div className="mt-4 pt-3 border-top d-flex align-items-center justify-content-between bg-light p-3 rounded">
                                                        <div className="text-muted d-flex align-items-center gap-2">
                                                            <i className="ti-announcement text-primary" style={{ fontSize: '18px' }}></i>
                                                            <span style={{ fontSize: '13px' }}>Click to apply settings and update doctor's profile instantly.</span>
                                                        </div>
                                                        <button 
                                                            type="button"
                                                            className="btn btn-primary px-4 py-2"
                                                            style={{ fontWeight: 600, backgroundColor: '#2563eb', borderColor: '#2563eb' }}
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                if (accountTab === "Password") {
                                                                    handleAdminPasswordSubmit(e);
                                                                } else if (accountTab === "Email Notification") {
                                                                    handleAdminEmailSubmit(e);
                                                                } else if (accountTab === "Delete Account") {
                                                                    handleAdminDeleteAccount(e);
                                                                } else if (accountTab === "Invoice Settings") {
                                                                    handleAdminInvoiceSettings(e);
                                                                }
                                                            }}
                                                        >
                                                            Save &amp; Update
                                                        </button>
                                                    </div>
                                                )}
                                            </div>
                                        </Col>
                                    </Row>
                                </Tab.Pane>

                                <Tab.Pane eventKey="profile_settings">
                                    <Row className="mt-2">
                                        <Col md={3}>
                                            <div className="d-flex flex-column gap-2 p-3 bg-light border rounded" style={{ minHeight: '400px' }}>
                                                <h6 className="text-muted text-uppercase font-size-sm mb-3 px-2" style={{ letterSpacing: '0.05em', fontWeight: 600 }}>Profile Sections</h6>
                                                {[
                                                    "Hospital Details",
                                                    "Experience & Education",
                                                    "Awards & Downloads",
                                                    "Registrations",
                                                    "Gallery",
                                                    "Default location",
                                                    "Social profiles"
                                                ].map((tabName) => (
                                                    <button
                                                        key={tabName}
                                                        type="button"
                                                        className={`btn text-start py-2 px-3 rounded transition-all ${
                                                            profileSettingsTab === tabName 
                                                            ? 'btn-primary shadow-sm font-weight-bold' 
                                                            : 'btn-link text-dark hover-bg-light border-0'
                                                        }`}
                                                        style={{ 
                                                            fontSize: '14px', 
                                                            transition: 'all 0.2s',
                                                            backgroundColor: profileSettingsTab === tabName ? '#2563eb' : 'transparent',
                                                            color: profileSettingsTab === tabName ? '#fff' : '#334155'
                                                        }}
                                                        onClick={() => setProfileSettingsTab(tabName)}
                                                    >
                                                        {tabName}
                                                    </button>
                                                ))}
                                            </div>
                                        </Col>
                                        <Col md={9}>
                                            <div className="p-4 border rounded bg-white shadow-sm d-flex flex-column justify-content-between" style={{ minHeight: '500px' }}>
                                                <div>
                                                    {profileSettingsTab === "Hospital Details" && (
                                                        <ProfilePersonalDetails PersonalDetailsformdata={profilePersonalDetailsFormdata} setPersonalDetailsFormdata={setProfilePersonalDetailsFormdata} />
                                                    )}
                                                    {profileSettingsTab === "Experience & Education" && (
                                                        <ExperienceEducation educations={profileEducations} setEducations={setProfileEducations} experiences={profileExperiences} setExperiences={setProfileExperiences} />
                                                    )}
                                                    {profileSettingsTab === "Awards & Downloads" && (
                                                        <AwardsDownloads awards={profileAwards} setAwards={setProfileAwards} downloads={profileDownloads} setDownloads={setProfileDownloads} />
                                                    )}
                                                    {profileSettingsTab === "Registrations" && (
                                                        <Registrations localRegistrations={profileRegistrations} setLocalRegistrations={setProfileRegistrations} isUploading={profileIsUploading} setIsUploading={setProfileIsUploading} isSaving={profileIsSaving} setIsSaving={setProfileIsSaving} hasChanges={profileHasChanges} setHasChanges={setProfileHasChanges} />
                                                    )}
                                                    {profileSettingsTab === "Gallery" && (
                                                        <Gallery galleryImages={profileGalleryImages} setGalleryImages={setProfileGalleryImages} videos={profileVideos} setVideos={setProfileVideos} newVideoUrl={profileNewVideoUrl} setNewVideoUrl={setProfileNewVideoUrl} isUploading={profileIsUploading} setIsUploading={setProfileIsUploading} galleryid={profileGalleryId} />
                                                    )}
                                                    {profileSettingsTab === "Default location" && (
                                                        <Defaultlocation selectedCountry={profileSelectedCountry} setSelectedCountry={setProfileSelectedCountry} searchAddress={profileSearchAddress} setSearchAddress={setProfileSearchAddress} mapCenter={profileMapCenter} setMapCenter={setProfileMapCenter} userdata={doctorData || {}} fullAddress={profileFullAddress} setFullAddress={setProfileFullAddress} />
                                                    )}
                                                    {profileSettingsTab === "Social profiles" && (
                                                        <SocialProfiles socialProfiles={profileSocialProfiles} setSocialProfiles={setProfileSocialProfiles} socialloading={profileSocialLoading} setSocialLoading={setProfileSocialLoading} />
                                                    )}
                                                </div>

                                                {/* Save & Update Actions */}
                                                <div className="mt-4 pt-3 border-top d-flex align-items-center justify-content-between bg-light p-3 rounded">
                                                    <div className="text-muted d-flex align-items-center gap-2">
                                                        <i className="ti-announcement text-primary" style={{ fontSize: '18px' }}></i>
                                                        <span style={{ fontSize: '13px' }}>Click to apply settings and update hospital's profile instantly.</span>
                                                    </div>
                                                    <button 
                                                        type="button"
                                                        className="btn btn-primary px-4 py-2"
                                                        style={{ fontWeight: 600, backgroundColor: '#2563eb', borderColor: '#2563eb' }}
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            if (profileSettingsTab === "Hospital Details") {
                                                                handleProfilePersonalDetailsSubmit(e);
                                                            } else if (profileSettingsTab === "Experience & Education") {
                                                                handleProfileExperienceEducationSubmit(e);
                                                            } else if (profileSettingsTab === "Awards & Downloads") {
                                                                handleProfileAwardsDownloadsSubmit(e);
                                                            } else if (profileSettingsTab === "Registrations") {
                                                                handleProfileRegistrationsSubmit(e);
                                                            } else if (profileSettingsTab === "Gallery") {
                                                                handleProfileGallerySubmit(e);
                                                            } else if (profileSettingsTab === "Default location") {
                                                                handleProfileDefaultLocationSubmit(e);
                                                            } else if (profileSettingsTab === "Social profiles") {
                                                                handleProfileSocialProfilesSubmit(e);
                                                            }
                                                        }}
                                                    >
                                                        Save &amp; Update
                                                    </button>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </Tab.Pane>

                                <Tab.Pane eventKey="appointment_settings">
                                    <div className="bg-white p-4 rounded shadow-sm border mt-2">
                                        <AppointmentSettingsComponent userId={id} doctorData={doctorData} onActivityLog={logAdminActivity} />
                                    </div>
                                </Tab.Pane>

                            </Tab.Content>

                        </Tab.Container>

                    </Card.Body>

                </Card>

                {/* Invoice Modal */}

                {showInvoiceModal && (

                    <AddInvoiceModel showAdd={showInvoiceModal} setShowAdd={setShowInvoiceModal} data={selectedInvoice} mode={invoiceMode} getdata={fetchInvoices} />

                )}

                {/* Poster/Banner Modal */}

                <Modal show={showMediaModal} onHide={handleCloseMediaModal} size="lg">

                    <Modal.Header>

                        <Modal.Title>

                            {mediaFormData.id ? 'Edit' : 'Add'} {mediaType === 'poster' ? 'Poster' : 'Banner'}

                        </Modal.Title>

                        <Button variant="secondary" onClick={handleCloseMediaModal}>

                            <i className="fas fa-times"></i>

                        </Button>

                    </Modal.Header>

                    <Form onSubmit={handleMediaFormSubmit}>

                        <Modal.Body>

                            <Row>

                                <Col md={12}>

                                    <Form.Group className="mb-3">

                                        <Form.Label>Name <span className="text-danger">*</span></Form.Label>

                                        <Form.Control

                                            type="text"

                                            name="name"

                                            value={mediaFormData.name}

                                            onChange={handleMediaFormChange}

                                            placeholder={`Enter ${mediaType} name`}

                                            required

                                            disabled={tasksLoading}

                                        />

                                    </Form.Group>

                                </Col>

                                <Col md={12}>

                                    <Form.Group className="mb-3">

                                        <Form.Label>Description <span className="text-danger">*</span></Form.Label>

                                        <Form.Control

                                            as="textarea"

                                            rows={3}

                                            name="description"

                                            value={mediaFormData.description}

                                            onChange={handleMediaFormChange}

                                            placeholder={`Enter ${mediaType} description`}

                                            required

                                            disabled={tasksLoading}

                                        />

                                    </Form.Group>

                                </Col>

                                <Col md={12}>

                                    <Form.Group className="mb-3">

                                        <Form.Label>Date <span className="text-danger">*</span></Form.Label>

                                        <Form.Control

                                            type="date"

                                            name="date"

                                            value={mediaFormData.date}

                                            onChange={handleMediaFormChange}

                                            min={new Date().toISOString().split('T')[0]}

                                            required

                                            disabled={tasksLoading}

                                        />

                                        <Form.Text className="text-muted">

                                            Select a date (only today and future dates are allowed)

                                        </Form.Text>

                                    </Form.Group>

                                </Col>

                                <Col md={6}>

                                    <Form.Group className="mb-3">

                                        <Form.Label>Reference Image</Form.Label>

                                        <Form.Control

                                            type="file"

                                            name="referenceImage"

                                            onChange={handleMediaFormChange}

                                            accept="image/*"

                                            disabled={tasksLoading}

                                        />

                                        <Form.Text className="text-muted">

                                            Upload a reference image (optional)

                                        </Form.Text>

                                    </Form.Group>

                                    {mediaFormData.referenceImage_preview && (

                                        <div className="mb-3">

                                            <img 

                                                src={URL.createObjectURL(mediaFormData.referenceImage_preview)} 

                                                alt="Reference preview" 

                                                style={{ maxWidth: '100%', maxHeight: '200px', objectFit: 'contain' }}

                                            />

                                            <p className="text-success mt-2">

                                                <i className="fas fa-check-circle"></i> File uploaded successfully

                                            </p>

                                        </div>

                                    )}

                                </Col>

                                <Col md={6}>

                                    <Form.Group className="mb-3">

                                        <Form.Label>Upload File</Form.Label>

                                        <Form.Control

                                            type="file"

                                            name="uploadFile"

                                            onChange={handleMediaFormChange}

                                            accept="image/*,application/pdf"

                                            disabled={tasksLoading}

                                        />

                                        <Form.Text className="text-muted">

                                            Upload the final file (optional)

                                        </Form.Text>

                                    </Form.Group>

                                    {mediaFormData.uploadFile_preview && (

                                        <div className="mb-3">

                                            {mediaFormData.uploadFile_preview.type.startsWith('image/') ? (

                                                <>

                                                    <img 

                                                        src={URL.createObjectURL(mediaFormData.uploadFile_preview)} 

                                                        alt="File preview" 

                                                        style={{ maxWidth: '100%', maxHeight: '200px', objectFit: 'contain' }}

                                                    />

                                                    <p className="text-success mt-2">

                                                        <i className="fas fa-check-circle"></i> File uploaded successfully

                                                    </p>

                                                </>

                                            ) : (

                                                <p className="text-success">

                                                    <i className="fas fa-check-circle"></i> {mediaFormData.uploadFile_preview.name} - Uploaded successfully

                                                </p>

                                            )}

                                        </div>

                                    )}

                                </Col>

                            </Row>

                        </Modal.Body>

                        <Modal.Footer>

                            <Button variant="secondary" onClick={handleCloseMediaModal} disabled={tasksLoading}>

                                Cancel

                            </Button>

                            <Button variant="primary" type="submit" disabled={tasksLoading}>

                                {tasksLoading ? (

                                    <>

                                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>

                                        Processing...

                                    </>

                                ) : (

                                    <>

                                        {mediaFormData.id ? 'Update' : 'Add'} {mediaType === 'poster' ? 'Poster' : 'Banner'}

                                    </>

                                )}

                            </Button>

                        </Modal.Footer>

                    </Form>

                </Modal>

                {/* Doctor Details Edit Modal */}

                <Modal show={showEditDoctorModal} onHide={handleCloseEditDoctorModal} size="lg" centered backdrop="static">

                    <Modal.Header closeButton className="text-white py-3 border-0" style={{ backgroundColor: "#2563eb" }}>
                        <Modal.Title className="font-weight-bold text-white" style={{ fontSize: "20px" }}>
                            <i className="fas fa-user-edit me-2"></i> Edit Hospital Details
                        </Modal.Title>
                    </Modal.Header>

                    <Form onSubmit={handleEditDoctorSubmit}>

                        <Modal.Body className="p-4" style={{ maxHeight: '70vh', overflowY: 'auto' }}>

                            <Tab.Container defaultActiveKey="edit-basic">

                            <style>{`

                                .custom-modal-pills .nav-link {

                                    color: #475569 !important;

                                    font-weight: 600;

                                    border-radius: 8px;

                                    transition: all 0.2s ease-in-out;

                                }

                                .custom-modal-pills .nav-link:hover {

                                    color: #2563eb !important;

                                    background-color: #f1f5f9;

                                }

                                .custom-modal-pills .nav-link.active {

                                    color: #ffffff !important;

                                    background-color: #2563eb !important;

                                    box-shadow: 0 4px 6px -1px rgba(37, 99, 235, 0.2);

                                }

                            `}</style>

                            <Nav variant="pills" className="justify-content-center mb-4 bg-light p-2 rounded custom-modal-pills">

                                    <Nav.Item>

                                        <Nav.Link eventKey="edit-basic" className="px-4 py-2 font-weight-bold">

                                            <i className="fas fa-info-circle me-2"></i>Basic Info

                                        </Nav.Link>

                                    </Nav.Item>

                                    <Nav.Item>

                                        <Nav.Link eventKey="edit-practice" className="px-4 py-2 font-weight-bold">

                                            <i className="fas fa-stethoscope me-2"></i>Practice Details

                                        </Nav.Link>

                                    </Nav.Item>

                                    <Nav.Item>

                                        <Nav.Link eventKey="edit-address" className="px-4 py-2 font-weight-bold">

                                            <i className="fas fa-map-marker-alt me-2"></i>Address & Contact

                                        </Nav.Link>

                                    </Nav.Item>

                                </Nav>

                                <Tab.Content>

                                    {/* Basic Info Tab */}

                                    <Tab.Pane eventKey="edit-basic">

                                        <Row>

                                            <Col md={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="font-weight-600">Hospital Name</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name="display_name"
                                                        value={editDoctorFormData.display_name}
                                                        onChange={handleEditDoctorChange}
                                                        placeholder="Enter hospital name"
                                                        required
                                                    />
                                                </Form.Group>
                                            </Col>

                                            <Col md={12}>

                                                <Form.Group className="mb-3">

                                                    <Form.Label className="font-weight-600">Languages</Form.Label>

                                                    <Form.Control

                                                        type="text"

                                                        name="languages"

                                                        value={editDoctorFormData.languages}

                                                        onChange={handleEditDoctorChange}

                                                        placeholder="e.g. English, Hindi, Telugu"

                                                    />

                                                </Form.Group>

                                            </Col>

                                            <Col md={12}>

                                                <Form.Group className="mb-3">

                                                    <Form.Label className="font-weight-600">Subheading / Clinical Designation</Form.Label>

                                                    <Form.Control

                                                        type="text"

                                                        name="subheading"

                                                        value={editDoctorFormData.subheading}

                                                        onChange={handleEditDoctorChange}

                                                        placeholder="e.g. Cardiologist & Heart Surgeon"

                                                    />

                                                </Form.Group>

                                            </Col>

                                            <Col md={12}>

                                                <Form.Group className="mb-3">

                                                    <Form.Label className="font-weight-600">Bio / Professional Description</Form.Label>

                                                    <Form.Control

                                                        as="textarea"

                                                        rows={4}

                                                        name="description"

                                                        value={editDoctorFormData.description}

                                                        onChange={handleEditDoctorChange}

                                                        placeholder="Provide a comprehensive profile description/bio..."

                                                    />

                                                </Form.Group>

                                            </Col>

                                        </Row>

                                    </Tab.Pane>

                                    {/* Practice Details Tab */}

                                    <Tab.Pane eventKey="edit-practice">

                                        <Row>

                                            <Col md={6}>

                                                <Form.Group className="mb-3">

                                                    <Form.Label className="font-weight-600">Starting Price (INR)</Form.Label>

                                                    <Form.Control

                                                        type="number"

                                                        name="starting_price"

                                                        value={editDoctorFormData.starting_price}

                                                        onChange={handleEditDoctorChange}

                                                        placeholder="Enter consult starting fee"

                                                    />

                                                </Form.Group>

                                            </Col>

                                            <Col md={6}>

                                                <Form.Group className="mb-3">

                                                    <Form.Label className="font-weight-600">Profile Rating (out of 5)</Form.Label>

                                                    <Form.Control

                                                        type="number"

                                                        step="0.1"

                                                        min="0"

                                                        max="5"

                                                        name="rating"

                                                        value={editDoctorFormData.rating}

                                                        onChange={handleEditDoctorChange}

                                                        placeholder="e.g. 4.8"

                                                    />

                                                </Form.Group>

                                            </Col>

                                            <Col md={6}>

                                                <Form.Group className="mb-3">

                                                    <Form.Label className="font-weight-600">Status</Form.Label>

                                                    <Form.Select

                                                        name="status"

                                                        value={editDoctorFormData.status}

                                                        onChange={handleEditDoctorChange}

                                                    >

                                                        <option value="1">Active</option>

                                                        <option value="0">Inactive</option>

                                                    </Form.Select>

                                                </Form.Group>

                                            </Col>



                                        </Row>

                                    </Tab.Pane>

                                    {/* Address & Contact Tab */}

                                    <Tab.Pane eventKey="edit-address">

                                        <Row>

                                            <Col md={6}>

                                                <Form.Group className="mb-3">

                                                    <Form.Label className="font-weight-600">Email Address</Form.Label>

                                                    <Form.Control

                                                        type="email"

                                                        name="email"

                                                        value={editDoctorFormData.email}

                                                        onChange={handleEditDoctorChange}

                                                        placeholder="Enter doctor's email"

                                                    />

                                                </Form.Group>

                                            </Col>

                                            <Col md={6}>

                                                <Form.Group className="mb-3">

                                                    <Form.Label className="font-weight-600">Phone Number</Form.Label>

                                                    <Form.Control

                                                        type="text"

                                                        name="phone"

                                                        value={editDoctorFormData.phone}

                                                        onChange={handleEditDoctorChange}

                                                        placeholder="Enter doctor's phone"

                                                    />

                                                </Form.Group>

                                            </Col>

                                            <Col md={12}>

                                                <Form.Group className="mb-3">

                                                    <Form.Label className="font-weight-600">Clinic / Hospital Address</Form.Label>

                                                    <Form.Control

                                                        as="textarea"

                                                        rows={2}

                                                        name="address"

                                                        value={editDoctorFormData.address}

                                                        onChange={handleEditDoctorChange}

                                                        placeholder="Enter complete clinical practice location address..."

                                                    />

                                                </Form.Group>

                                            </Col>

                                            <Col md={4}>

                                                <Form.Group className="mb-3">

                                                    <Form.Label className="font-weight-600">City</Form.Label>

                                                    <Form.Control

                                                        type="text"

                                                        name="city"

                                                        value={editDoctorFormData.city}

                                                        onChange={handleEditDoctorChange}

                                                        placeholder="City"

                                                    />

                                                </Form.Group>

                                            </Col>

                                            <Col md={4}>

                                                <Form.Group className="mb-3">

                                                    <Form.Label className="font-weight-600">State</Form.Label>

                                                    <Form.Control

                                                        type="text"

                                                        name="state"

                                                        value={editDoctorFormData.state}

                                                        onChange={handleEditDoctorChange}

                                                        placeholder="State"

                                                    />

                                                </Form.Group>

                                            </Col>

                                            <Col md={4}>

                                                <Form.Group className="mb-3">

                                                    <Form.Label className="font-weight-600">Pincode</Form.Label>

                                                    <Form.Control

                                                        type="text"

                                                        name="pincode"

                                                        value={editDoctorFormData.pincode}

                                                        onChange={handleEditDoctorChange}

                                                        placeholder="Pincode"

                                                    />

                                                </Form.Group>

                                            </Col>

                                        </Row>

                                    </Tab.Pane>

                                </Tab.Content>

                            </Tab.Container>

                        </Modal.Body>

                        <Modal.Footer className="bg-light">

                            <Button variant="outline-secondary" onClick={handleCloseEditDoctorModal} className="px-4">

                                Cancel

                            </Button>

                            <Button variant="primary" type="submit" className="px-4 font-weight-bold shadow-sm border-0" style={{ backgroundColor: "#2563eb", borderColor: "#2563eb", boxShadow: "0 4px 6px -1px rgba(37, 99, 235, 0.2)" }}>
                                <i className="fas fa-save me-2"></i>Save Doctor Details
                            </Button>

                        </Modal.Footer>

                    </Form>

                </Modal>

            </div>

        </div>

    );

};

export default HospitalProfileDetails;

